// Code review - In Progress
// Documentation - In Progress

const countryMasterHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:w-12 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "Country",
    key: "CountryName",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Country Code",
    key: "CountryCode",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5 m-auto",
  },
];

const stateExcelHeader = [
  "S.No",
  "Country",
  "State Name",
  "State Code",
  "Created By",
];

const stateMasterHeader = [
  {
    title: "S.No.",
    key: "Sno",
    width: "md:w-14 2xl:w-12 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "Country",
    key: "CountryName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "State",
    key: "StateName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "State Code",
    key: "StateCode",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
];

const UOMHeader = [
  {
    title: "S.No.",
    key: "Sno",
    width: "md:w-14 2xl:w-12 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  // {
  //   title: "Unit of Measure",
  //   key: "CommodityUOM",
  //   width: "flex-1 px-1 py-1.5 ",
  //   width1: "text-red-500",
  // },

  {
    title: "Unit of Measure",
    key: "CommodityUOM",
    width: "md:w-40 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "Description",
    key: "Description",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
];

const servicesExcelExportHeader = [
  {
    title: "S.No.",
    key: "Sno",
    width: "md:w-14 2xl:w-12 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  }, {
    title: "TxnServicesId",
    key: "CountryName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Client Id.",
    key: "CountryName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "ClientName_en",
    key: "StateName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ClientName_ta",
    key: "StateName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ClientName_hi",
    key: "StateName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ClientName_mr",
    key: "StateName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ClientName_gu",
    key: "StateName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ClientName_kn",
    key: "StateName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ClientName_ml",
    key: "StateName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ClientName_te",
    key: "StateName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ClientName_bn",
    key: "StateName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ClientName_or",
    key: "StateName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ClientMotherName_en",
    key: "StateCode",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ClientMotherName_ta",
    key: "StateCode",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ClientMotherName_hi",
    key: "StateCode",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ClientMotherName_mr",
    key: "StateCode",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ClientMotherName_gu",
    key: "StateCode",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ClientMotherName_kn",
    key: "StateCode",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ClientMotherName_ml",
    key: "StateCode",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ClientMotherName_te",
    key: "StateCode",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ClientMotherName_bn",
    key: "StateCode",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ClientMotherName_or",
    key: "StateCode",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Phone Number",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Date",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReasonForVisit_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReasonForVisit_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReasonForVisit_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReasonForVisit_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReasonForVisit_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReasonForVisit_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReasonForVisit_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReasonForVisit_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReasonForVisit_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReasonForVisit_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Branch / Project",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "SDP",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Area",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Project",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ServicesCategory_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ServicesCategory_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ServicesCategory_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ServicesCategory_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ServicesCategory_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ServicesCategory_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ServicesCategory_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ServicesCategory_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ServicesCategory_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ServicesCategory_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ServicesSubCategory_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ServicesSubCategory_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ServicesSubCategory_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ServicesSubCategory_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ServicesSubCategory_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ServicesSubCategory_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ServicesSubCategory_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ServicesSubCategory_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ServicesSubCategory_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ServicesSubCategory_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Services_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Services_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Services_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Services_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Services_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Services_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Services_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Services_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Services_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Services_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ResultType",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "UOM",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "PACServices_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "PACServices_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "PACServices_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "PACServices_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "PACServices_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "PACServices_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "PACServices_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "PACServices_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "PACServices_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "PACServices_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Brand_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Brand_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Brand_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Brand_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Brand_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Brand_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Brand_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Brand_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Brand_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Brand_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Item",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Charges",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "FPUser",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CRSFollowUp",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferralFollowUp",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Remarks_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Remarks_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Remarks_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Remarks_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Remarks_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Remarks_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Remarks_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Remarks_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Remarks_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Remarks_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityType_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "CommodityType_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityType_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityType_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityType_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityType_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityType_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityType_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityType_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityType_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityCategory_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityCategory_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityCategory_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityCategory_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityCategory_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityCategory_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityCategory_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityCategory_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityCategory_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityCategory_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityName_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityName_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityName_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityName_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityName_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityName_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityName_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityName_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityName_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityName_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityBrand_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityBrand_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityBrand_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityBrand_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityBrand_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityBrand_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityBrand_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityBrand_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityBrand_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "CommodityBrand_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Quantity",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "UOM",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Charges",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Appoinment Date",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "AppointmentWith_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "AppointmentWith_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "AppointmentWith_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "AppointmentWith_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "AppointmentWith_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "AppointmentWith_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "AppointmentWith_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "AppointmentWith_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "AppointmentWith_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "AppointmentWith_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Email",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "MeetingLink",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Created By",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
];

const iecExcelExportHeader = [
  {
    title: "S.No.",
    key: "Sno",
    width: "md:w-14 2xl:w-12 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "IEC Id",
    key: "Date",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "Date",
    key: "Date",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "State",
    key: "State",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "Branch / Project",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  }, {
    title: "SDP",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  }, {
    title: "Area",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Interpersonal Contact No.",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Channel",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name2_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name2_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "LocalityStreet_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "LocalityStreet_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "LocalityStreet_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "LocalityStreet_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "LocalityStreet_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "LocalityStreet_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "LocalityStreet_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "LocalityStreet_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "LocalityStreet_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "LocalityStreet_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "District_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Block_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Block_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "City/Village_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "ParticipantName_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Age",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "MobileNumber",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferredTo_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferredTo_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "FallowUpDate",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Descripition_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Created By",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

];

const iecGDExcelExportHeader = [
  {
    title: "S.No.",
    key: "Sno",
    width: "md:w-14 2xl:w-12 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "IEC Id",
    key: "Date",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "Date",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "State",
    key: "State",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "Branch / Project",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  }, {
    title: "SDP",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  }, {
    title: "Area",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Group Discussion No.",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Channel",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name2_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name2_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Venue_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Venue_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "District_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Block_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Block_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "City/Village_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "File Upload",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Male",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Female",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Other",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "total",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Age 10-14",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Age 15-24",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Age 25+",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Age Total",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ParticipantName_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Age",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "MobileNumber",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferredTo_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferredTo_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "FallowUpDate",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Descripition_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Created By",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

];

const iecGMMExcelExportHeader = [
  {
    title: "S.No.",
    key: "Sno",
    width: "md:w-14 2xl:w-12 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "IEC Id",
    key: "Date",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "Date",
    key: "Date",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "State",
    key: "State",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "Branch / Project",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  }, {
    title: "SDP",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  }, {
    title: "Area",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Group Discussion No.",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },



  {
    title: "Male",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Female",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Other",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "total",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Age 10-14",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Age 15-24",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Age 25+",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Age Total",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Channel",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name2_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name2_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Venue_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Venue_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "District_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Block_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Block_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "City/Village_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "File Upload",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "ParticipantName_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Age",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "MobileNumber",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferredTo_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferredTo_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "FallowUpDate",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Descripition_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Created By",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
];

const iecMMExcelExportHeader = [
  {
    title: "S.No.",
    key: "Sno",
    width: "md:w-14 2xl:w-12 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "IEC Id",
    key: "Date",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "Date",
    key: "Date",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "State",
    key: "State",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "Branch / Project",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  }, {
    title: "SDP",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  }, {
    title: "Area",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Group Discussion No.",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Topic_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Channel",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name1_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name2_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Staff Name2_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Staff Name2_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Venue_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Venue_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "Venue_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "District_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "District_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Block_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Block_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Block_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "City/Village_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "City/Village_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Total no. of participants (Estimated)",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Collaborative NGO/Partner Organization",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Mode",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Mass / Mid / Social Media",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "File Upload",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "ParticipantName_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ParticipantName_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Age",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Gender_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "MobileNumber",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferralService_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferredTo_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "ReferredTo_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "ReferredTo_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
  {
    title: "FallowUpDate",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },


  {
    title: "Descripition_en",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_ta",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_hi",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_mr",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_gu",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_kn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_ml",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_te",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_bn",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Descripition_or",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },

  {
    title: "Created By",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
];

const areaMasterHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-14 px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Country",
    key: "CountryName_en",
    width: "md:w-24 lg:w-20 xl:w-36  px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "State",
    key: "StateName_en",
    width: "md:w-32 lg:w-28 xl:w-40  px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Branch/Project",
    key: "LocationName_en",
    width: "md:w-28 lg:w-28 xl:w-36 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "S.D.P.",
    key: "SDP_en",
    width: "md:w-24 lg:w-24 xl:w-40 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Area",
    key: "AreaName_en",
    width: "md:w-28 lg:w-28 xl:w-56 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Area Code",
    key: "AreaCode",
    width: "md:w-20 lg:w-20 xl:w-20  px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5 ",
  },
];
const sdpMasterHeader = [
  {
    title: "S.No.",
    key: "Sno",
    width: "md:w-14 2xl:w-12 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Country",
    key: "CountryName_en",
    width: "md:w-40 lg:w-56 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "State",
    key: "StateName_en",
    width: "md:w-40 lg:w-60 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Branch/Project",
    key: "LocationName_en",
    width: "md:w-32 lg:w-60 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "S.D.P.",
    key: "SDP_en",
    width: "md:w-40 lg:w-72 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "S.D.P. Code",
    key: "SDPCode",
    width: "md:w-20 lg:w-52 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5",
  },
];
const locationMasterHeader = [
  {
    title: "S.No.",
    key: "LocationSno",
    width: "md:w-14 2xl:w-12 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Country",
    key: "CountryName_en",
    width: "md:w-24 lg:w-40 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "State",
    key: "StateName_en",
    width: "md:w-24 lg:w-40 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Branch/Project",
    key: "LocationName_en",
    width: "md:w-28 lg:w-40 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Branch/Project Code",
    key: "LocationCode",
    width: "md:w-36 lg:w-40 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Email Id",
    key: "Email",
    width: "md:w-44 lg:w-60 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5",
  },
];
const languageMasterHeader = [
  {
    title: "S.No.",
    key: "languageSno",
    width: "md:w-12 2xl:w-12 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "Language",
    key: "Language",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Language Code",
    key: "LanguageKey",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  // {
  //   title: "Action",
  //   key: "action",
  //   width: " px-1 py-1.5 m-auto",
  // },
];

const languageMasterExportHeader = [
  {
    title: "S.No.",
    key: "languageSno",
    width: "md:w-12 2xl:w-12 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "MstLanguageId",
    key: "MstLanguageId",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Language",
    key: "Language",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Language Code",
    key: "LanguageCode",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Created By",
    key: "FullName_en",
    width: " px-1 py-1.5 m-auto",
  },
];

const servicesCategoryHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-14 2xl:w-72 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "Category",
    key: "ServicesCategory_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
];

const servicesSubCategoryHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:w-12 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "Category",
    key: "ServicesCategory_en",
    width: "flex-1 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "Sub-Category",
    key: "ServicesSubCategory_en",
    width: "flex-1 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5 m-auto",
  },
];

const servicesMasterHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:w-12 px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Category",
    key: "ServicesCategory_en",
    width: "md:w-28 lg:w-28 2xl:w-48 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Sub-Category",
    key: "ServicesSubCategory_en",
    width: "md:w-28 lg:w-28 2xl:w-48 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Services",
    key: "Services_en",
    width: "md:w-44 lg:w-72 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Test Result Type",
    key: "ResultType",
    width: "md:w-28 lg:w-28 2xl:w-28 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Charges",
    key: "Charges",
    width: "md:w-24 lg:w-24 2xl:w-24 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5 ",
    width1: "text-red-500",
  },
];
const servicesMasterExportHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:w-12 px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "MstServicesId",
    key: "MstServicesId",
    width: "md:w-28 lg:w-48 2xl:w-48 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Category",
    key: "ServicesCategory_en",
    width: "md:w-28 lg:w-48 2xl:w-48 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Sub-Category",
    key: "ServicesSubCategory_en",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Services_en",
    key: "Services_en",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Services_ta",
    key: "Services_en",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Services_hi",
    key: "Services_en",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Services_mr",
    key: "Services_en",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Services_gu",
    key: "Services_en",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "Services_kn",
    key: "Services_en",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Services_ml",
    key: "Services_en",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "Services_te",
    key: "Services_en",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Services_bn",
    key: "Services_en",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Services_or",
    key: "Services_en",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Items Provided",
    key: "ItemsProvided",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Test Result Type",
    key: "ResultType",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Service Provision",
    key: "ServiceProvisionNames",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Result UOM",
    key: "ResultUOM",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Renewal Supply",
    key: "RenewalSupply",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Charges",
    key: "Charges",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "PAC",
    key: "PACServices",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "FP Dropout",
    key: "FPDropout",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "CYP",
    key: "CYP",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "CYP Conversion Factor",
    key: "CYPConversionFactor",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "FPItemProvided_en",
    key: "FPItemProvided_en",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "FPItemProvided_ta",
    key: "FPItemProvided_en",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "FPItemProvided_hi",
    key: "FPItemProvided_en",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "FPItemProvided_mr",
    key: "FPItemProvided_en",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "FPItemProvided_gu",
    key: "FPItemProvided_en",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "FPItemProvided_kn",
    key: "FPItemProvided_en",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "FPItemProvided_ml",
    key: "FPItemProvided_en",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "FPItemProvided_te",
    key: "FPItemProvided_en",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "FPItemProvided_bn",
    key: "FPItemProvided_en",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "FPItemProvided_or",
    key: "FPItemProvided_en",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "AbortionClients_en",
    key: "AbortionClients",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "AbortionClients_ta",
    key: "AbortionClients",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "AbortionClients_hi",
    key: "AbortionClients",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "AbortionClients_mr",
    key: "AbortionClients",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "AbortionClients_gu",
    key: "AbortionClients",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "AbortionClients_kn",
    key: "AbortionClients",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "AbortionClients_ml",
    key: "AbortionClients",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "AbortionClients_te",
    key: "AbortionClients",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "AbortionClients_bn",
    key: "AbortionClients",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "AbortionClients_or",
    key: "AbortionClients",
    width: "md:w-44 lg:w-56 2xl:w-48 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Created By",
    key: "FullName_en",
    width: " px-1 py-1.5 ",
    width1: "text-red-500",
  },
];
const userHeaders = [
  {
    title: "S.No.",
    width: "md:w-10 lg:w-10 xl:w-12 2xl:w-14 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "User Name",
    key: "UserName",
    width: "md:w-24 lg:w-24 xl:w-40 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Branch",
    key: "LocationName_en",
    width: "md:w-24 lg:w-24 xl:w-32 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Email",
    key: "UserEmail",
    width: "md:w-32 lg:w-36 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Mobile",
    key: "UserMobile",
    width: "md:w-28 lg:w-24 xl:w-36 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Designation",
    key: "Designation",
    width: "md:w-28 lg:w-24 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Role",
    key: "RoleName",
    width: "md:w-28 lg:w-24 xl:w-32 2xl:w-96 px-1 py-1.5 mr-auto ",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5  ",
  },
];

const clientHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12  lg:w-12 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Client Id",
    key: "ClientId",
    // width: "md:w-32 lg:w-32 xl:w-64 2xl:w-72  px-1 py-1.5",
    width: "md:w-64 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Ex. Client Id",
    key: "ClientExistingClientId",
    width: "md:w-28 lg:w-32 xl:w-52 2xl:w-72  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Client Name",
    key: "ClientName_en",
    width: "md:w-28 lg:w-28 xl:w-44 2xl:w-72  px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Mother's Name",
    key: "ClientMotherName_en",
    width:
      "md:w-28 whitespace-normal break-words xl:w-32 2xl:w-72 lg:w-28 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Gender / Age",
    key: "ClientGenderAge_en",
    width: "md:w-28 2xl:w-44 lg:w-28 2xl:w-72  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Phone",
    key: "GridClientPhoneNo",
    width: "md:w-24 lg:w-24 2xl:w-72   px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Staff Name",
    key: "UserName_en",
    width: "md:w-28 lg:w-28 xl:w-44 2xl:w-72  px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action1",
    width: " px-1 py-1.5",
  },
];
const clientHeadersExcel = [
  { title: "S.No.", key: "sno", width: 8 },

  { title: "MstClientId", key: "MstClientId", width: 12 },
  { title: "Client Id", key: "ClientId", width: 35 },

  // First Name
  { title: "Client First Name En", key: "ClientFirstName_en" },
  { title: "Client First Name Ta", key: "ClientFirstName_ta" },
  { title: "Client First Name Hi", key: "ClientFirstName_hi" },
  { title: "Client First Name Mr", key: "ClientFirstName_mr" },
  { title: "Client First Name Gu", key: "ClientFirstName_gu" },
  { title: "Client First Name Ml", key: "ClientFirstName_ml" },
  { title: "Client First Name Te", key: "ClientFirstName_te" },
  { title: "Client First Name Kn", key: "ClientFirstName_kn" },
  { title: "Client First Name Bn", key: "ClientFirstName_bn" },
  { title: "Client First Name Or", key: "ClientFirstName_or" },

  // Middle Name
  { title: "Client Middle Name En", key: "ClientMiddleName_en" },
  { title: "Client Middle Name Ta", key: "ClientMiddleName_ta" },
  { title: "Client Middle Name Hi", key: "ClientMiddleName_hi" },
  { title: "Client Middle Name Mr", key: "ClientMiddleName_mr" },
  { title: "Client Middle Name Gu", key: "ClientMiddleName_gu" },
  { title: "Client Middle Name Ml", key: "ClientMiddleName_ml" },
  { title: "Client Middle Name Te", key: "ClientMiddleName_te" },
  { title: "Client Middle Name Kn", key: "ClientMiddleName_kn" },
  { title: "Client Middle Name Bn", key: "ClientMiddleName_bn" },
  { title: "Client Middle Name Or", key: "ClientMiddleName_or" },

  // Last Name
  { title: "Client Last Name En", key: "ClientLastName_en" },
  { title: "Client Last Name Ta", key: "ClientLastName_ta" },
  { title: "Client Last Name Hi", key: "ClientLastName_hi" },
  { title: "Client Last Name Mr", key: "ClientLastName_mr" },
  { title: "Client Last Name Gu", key: "ClientLastName_gu" },
  { title: "Client Last Name Ml", key: "ClientLastName_ml" },
  { title: "Client Last Name Te", key: "ClientLastName_te" },
  { title: "Client Last Name Kn", key: "ClientLastName_kn" },
  { title: "Client Last Name Bn", key: "ClientLastName_bn" },
  { title: "Client Last Name Or", key: "ClientLastName_or" },

  // Mother Name
  { title: "Client Mother Name En", key: "ClientMotherName_en" },
  { title: "Client Mother Name Ta", key: "ClientMotherName_ta" },
  { title: "Client Mother Name Hi", key: "ClientMotherName_hi" },
  { title: "Client Mother Name Mr", key: "ClientMotherName_mr" },
  { title: "Client Mother Name Gu", key: "ClientMotherName_gu" },
  { title: "Client Mother Name Ml", key: "ClientMotherName_ml" },
  { title: "Client Mother Name Te", key: "ClientMotherName_te" },
  { title: "Client Mother Name Kn", key: "ClientMotherName_kn" },
  { title: "Client Mother Name Bn", key: "ClientMotherName_bn" },
  { title: "Client Mother Name Or", key: "ClientMotherName_or" },

  { title: "Date Of Birth", key: "ClientDateOfBirth" },
  { title: "Age", key: "Age" },

  { title: "Gender En", key: "Gender_en" },
  // { title: "Gender Ta", key: "Gender_ta" },
  // { title: "Gender Hi", key: "Gender_hi" },
  // { title: "Gender Mr", key: "Gender_mr" },
  // { title: "Gender Gu", key: "Gender_gu" },
  // { title: "Gender Kn", key: "Gender_kn" },
  // { title: "Gender Ml", key: "Gender_ml" },
  // { title: "Gender Te", key: "Gender_te" },
  // { title: "Gender Bn", key: "Gender_bn" },
  // { title: "Gender Or", key: "Gender_or" },
  { title: "Religion", key: "ClientReligion" },
  { title: "Marital Status", key: "ClientMaritalStatus" },

  // Education
  { title: "Education En", key: "Education_en" },
  // { title: "Education Ta", key: "Education_ta" },
  // { title: "Education Hi", key: "Education_hi" },
  // { title: "Education Mr", key: "Education_mr" },
  // { title: "Education Gu", key: "Education_gu" },
  // { title: "Education Kn", key: "Education_kn" },
  // { title: "Education Ml", key: "Education_ml" },
  // { title: "Education Te", key: "Education_te" },
  // { title: "Education Bn", key: "Education_bn" },
  // { title: "Education Or", key: "Education_or" },

  // Occupation
  { title: "Occupation En", key: "Occupation_en" },
  // { title: "Occupation Ta", key: "Occupation_ta" },
  // { title: "Occupation Hi", key: "Occupation_hi" },
  // { title: "Occupation Mr", key: "Occupation_mr" },
  // { title: "Occupation Gu", key: "Occupation_gu" },
  // { title: "Occupation Kn", key: "Occupation_kn" },
  // { title: "Occupation Ml", key: "Occupation_ml" },
  // { title: "Occupation Te", key: "Occupation_te" },
  // { title: "Occupation Bn", key: "Occupation_bn" },
  // { title: "Occupation Or", key: "Occupation_or" },

  { title: "Register Date", key: "ClientRegisterDate" },
  { title: "Have you attended ", key: "Attended_en" },

  // Referral Source
  { title: "Referral Source En", key: "ReferralSource_en" },
  // { title: "Referral Source Ta", key: "ReferralSource_ta" },
  // { title: "Referral Source Hi", key: "ReferralSource_hi" },
  // { title: "Referral Source Mr", key: "ReferralSource_mr" },
  // { title: "Referral Source Gu", key: "ReferralSource_gu" },
  // { title: "Referral Source Kn", key: "ReferralSource_kn" },
  // { title: "Referral Source Ml", key: "ReferralSource_ml" },
  // { title: "Referral Source Te", key: "ReferralSource_te" },
  // { title: "Referral Source Bn", key: "ReferralSource_bn" },
  // { title: "Referral Source Or", key: "ReferralSource_or" },

  { title: "Existing Client Id", key: "ClientExistingClientId" },
  { title: "Phone No", key: "ClientPhoneNo" },

  // Mobile Belongs To
  { title: "Mobile Belongs To En", key: "MobileBelongsTo_en" },
  // { title: "Mobile Belongs To Ta", key: "MobileBelongsTo_ta" },
  // { title: "Mobile Belongs To Hi", key: "MobileBelongsTo_hi" },
  // { title: "Mobile Belongs To Mr", key: "MobileBelongsTo_mr" },
  // { title: "Mobile Belongs To Gu", key: "MobileBelongsTo_gu" },
  // { title: "Mobile Belongs To Ml", key: "MobileBelongsTo_ml" },
  // { title: "Mobile Belongs To Te", key: "MobileBelongsTo_te" },
  // { title: "Mobile Belongs To Kn", key: "MobileBelongsTo_kn" },
  // { title: "Mobile Belongs To Bn", key: "MobileBelongsTo_bn" },
  // { title: "Mobile Belongs To Or", key: "MobileBelongsTo_or" },

  // Residence
  { title: "Residence En", key: "Residence_en" },
  // { title: "Residence Ta", key: "Residence_ta" },
  // { title: "Residence Hi", key: "Residence_hi" },
  // { title: "Residence Mr", key: "Residence_mr" },
  // { title: "Residence Gu", key: "Residence_gu" },
  // { title: "Residence Kn", key: "Residence_kn" },
  // { title: "Residence Ml", key: "Residence_ml" },
  // { title: "Residence Te", key: "Residence_te" },
  // { title: "Residence Bn", key: "Residence_bn" },
  // { title: "Residence Or", key: "Residence_or" },

  // State
  { title: "State Name En", key: "StateName_en" },
  // { title: "State Name Ta", key: "StateName_ta" },
  // { title: "State Name Hi", key: "StateName_hi" },
  // { title: "State Name Mr", key: "StateName_mr" },
  // { title: "State Name Gu", key: "StateName_gu" },
  // { title: "State Name Kn", key: "StateName_kn" },
  // { title: "State Name Ml", key: "StateName_ml" },
  // { title: "State Name Te", key: "StateName_te" },
  // { title: "State Name Bn", key: "StateName_bn" },
  // { title: "State Name Or", key: "StateName_or" },

  // Location
  { title: "Branch / Project En", key: "LocationName_en" },
  // { title: "Location Name Ta", key: "LocationName_ta" },
  // { title: "Location Name Hi", key: "LocationName_hi" },
  // { title: "Location Name Mr", key: "LocationName_mr" },
  // { title: "Location Name Gu", key: "LocationName_gu" },
  // { title: "Location Name Ml", key: "LocationName_ml" },
  // { title: "Location Name Te", key: "LocationName_te" },
  // { title: "Location Name Kn", key: "LocationName_kn" },
  // { title: "Location Name Bn", key: "LocationName_bn" },
  // { title: "Location Name Or", key: "LocationName_or" },

  // SDP
  { title: "SDP En", key: "SDP_en" },
  // { title: "SDP Ta", key: "SDP_ta" },
  // { title: "SDP Hi", key: "SDP_hi" },
  // { title: "SDP Mr", key: "SDP_mr" },
  // { title: "SDP Gu", key: "SDP_gu" },
  // { title: "SDP Kn", key: "SDP_kn" },
  // { title: "SDP Ml", key: "SDP_ml" },
  // { title: "SDP Te", key: "SDP_te" },
  // { title: "SDP Bn", key: "SDP_bn" },
  // { title: "SDP Or", key: "SDP_or" },

  // Area
  { title: "Area Name En", key: "AreaName_en" },
  // { title: "Area Name Ta", key: "AreaName_ta" },
  // { title: "Area Name Hi", key: "AreaName_hi" },
  // { title: "Area Name Mr", key: "AreaName_mr" },
  // { title: "Area Name Gu", key: "AreaName_gu" },
  // { title: "Area Name Kn", key: "AreaName_kn" },
  // { title: "Area Name Ml", key: "AreaName_ml" },
  // { title: "Area Name Te", key: "AreaName_te" },
  // { title: "Area Name Bn", key: "AreaName_bn" },
  // { title: "Area Name Or", key: "AreaName_or" },

  { title: "Address En", key: "ClientAddress_en" },
  { title: "Address Hi", key: "ClientAddress_hi" },
  { title: "Address Ta", key: "ClientAddress_ta" },
  { title: "Address Mr", key: "ClientAddress_mr" },
  { title: "Address Gu", key: "ClientAddress_gu" },
  { title: "Address Ml", key: "ClientAddress_ml" },
  { title: "Address Te", key: "ClientAddress_te" },
  { title: "Address Kn", key: "ClientAddress_kn" },
  { title: "Address Bn", key: "ClientAddress_bn" },
  { title: "Address Or", key: "ClientAddress_or" },

  { title: "Zip / Pincode", key: "ClientPinCode" },
  { title: "No Of Living Children", key: "ClientNoOfLivingChildren" },
  { title: "Children Years", key: "NoOfLivingChildrenYears" },
  { title: "Children Months", key: "NoOfLivingChildrenMonths" },
  { title: "Children Days", key: "NoOfLivingChildrenDays" },
  { title: "Child Gender", key: "ChildGender_en" },
  { title: "Disability", key: "Disability_en" },
  { title: "Marginalized And Excluded Clients", key: "MEClients_en" },
  { title: "BPL cardholder", key: "DrpYesNo_en" },
  { title: "Blood Group", key: "BloodGroup" },
  { title: "Tobacco User", key: "tobacco_DrpYesNo_en" },
  { title: "Alcohol User", key: "al_DrpYesNo_en" },

  { title: "Height", key: "ClientHeight" },
  { title: "Weight", key: "ClientWeight" },

  { title: "Cycle In Days", key: "ClientCycleInDays" },
  { title: "Duration In Days", key: "ClientDurationInDays" },
  { title: "Regularity", key: "reg_DrpYesNo_en" },

  { title: "LMP Date", key: "ClientLastMenstrualPeriodDate" },
  { title: "Gravida", key: "ClientGravida" },
  { title: "Para", key: "ClientPara" },
  { title: "Neonatal Deaths", key: "ClientNoOfNeonatalDeaths" },
  { title: "Currently Pregnant", key: "pregnant_DrpYesNo_en" },

  { title: "Abortions", key: "ClientAbortions" },
  { title: "Still Birth", key: "ClientStillBirth" },
  { title: "Ever Used a FP Method", key: "fp_DrpYesNo_en" },
  { title: "FP Method", key: "FPMethod_en" },

  { title: "Diabetes", key: "dia_DrpYesNo_en" },
  { title: "Hypertension", key: "hyp_DrpYesNo_en" },
  { title: "Asthma", key: "ast_DrpYesNo_en" },
  { title: "Tuberculosis", key: "tub_DrpYesNo_en" },
  { title: "Cancer Specify En", key: "ClientCancerSpecify_en" },
  { title: "Drug allergies", key: "drug_DrpYesNo_en" },

  { title: "Other Specify En", key: "ClientOtherSpecify_en" },

  { title: "Additional Notes En", key: "ClientAdditionalNotes_en" },

  { title: "Created By", key: "CreatedByName" },
];
const cSEInSchoolExcel = [
  { title: "S.No.", key: "sno" },

  { title: "TxnInSchoolSessionId", key: "TxnInSchoolSessionId" },
  { title: "School Name", key: "SchoolName", width: 40 },
  { title: "Class", key: "MstCSEClass", },
  { title: "Division", key: "Division" },
  { title: "Date", key: "Date" },
  { title: "ResourcepersonType", key: "ResourcepersonType" },
  { title: "ResourcesName 1", key: "ResourcesName1" },
  { title: "ResourcesName 2 ", key: "ResourcesName2" },
  { title: "StartTime ", key: "StartTime" },
  { title: "EndTime ", key: "EndTime" },
  { title: "Sessions ", key: "Sessions" },
  { title: "Modules ", key: "Modules" },
  { title: "Remarks ", key: "Remarks" },
  { title: "StudentName ", key: "StudentName" },
  { title: "Roll ID.", key: "StudentId" },
  { title: "Gender_en ", key: "Gender_en" },
  { title: "Age ", key: "Age" },
  { title: "ReferralServices ", key: "ReferralServices" },
  { title: "ReferredTo_en ", key: "ReferredTo_en" },

  { title: "Created By", key: "CreatedByName" },
];
const cSEOutSchoolExcel = [
  { title: "S.No.", key: "sno" },

  { title: "TxnOutSchoolSessionId", key: "TxnOutSchoolSessionId" },
  { title: "Youth Group Name", key: "YouthGroupName", width: 30 },
  { title: "Date", key: "Date" },
  { title: "ResourcepersonType", key: "ResourcepersonType" },
  { title: "ResourcesName 1", key: "ResourcesName1" },
  { title: "ResourcesName 2 ", key: "ResourcesName2" },
  { title: "StartTime ", key: "StartTime" },
  { title: "EndTime ", key: "EndTime" },
  { title: "Sessions ", key: "Sessions" },
  { title: "Modules ", key: "Modules" },
  { title: "Remarks ", key: "Remarks" },

  { title: "Youth ID. ", key: "YouthId" },
  { title: "YouthName ", key: "YouthName" },
  { title: "Gender_en ", key: "Gender_en" },
  { title: "Age ", key: "Age" },
  { title: "ReferralServices ", key: "ReferralServices" },
  { title: "ReferredTo_en ", key: "ReferredTo_en" },
  { title: "Created By", key: "CreatedByName" },
];
const roleMasterHeader = [
  {
    title: "S.No.",
    key: "MstRoleId",
    width: "md:w-12 2xl:w-12 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "Role / Group",
    key: "RoleName",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Description",
    key: "RoleDiscription",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
];

const campsMeetingsMasterHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:w-12 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "Type",
    key: "camps",
    width: "md:w-20 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Title",
    key: "campsTitle",
    width:
      "md:w-60  whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "From",
    key: "campsFrom",
    width: "md:w-32 2xl:flex-1 whitespace-pre-line px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "To",
    key: "campsTo",
    width: "md:w-32 2xl:flex-1 whitespace-pre-line px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Participant School",
    key: "school",
    width:
      "md:w-72 whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Address",
    key: "address",
    width: "md:w-24 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " 2xl:flex-1 px-1 py-1.5 ",
  },
];
const healthCareHeaders = [
  {
    title: "S.No.",
    key: "healthcareAutoUserId",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-24 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Photo",
    key: "HealthCareProviderPhoto",
    width: "md:w-20 lg:w-20  xl:w-20 2xl:28 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "H.C.P. Name",
    key: "HealthcareProviderName_en",
    width: "md:w-28 lg:w-24  xl:w-44 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: " H.C.P. Type",
    key: "Speciality_en",
    width: "md:w-24 lg:w-24  xl:w-36 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: " Email",
    key: "HealthcareProviderEmail",
    width: "md:w-32 lg:w-28  xl:w-52 2xl:m-auto  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: " Mobile",
    key: "HealthcareProviderPhoneNo",
    width: "md:w-28 lg:w-24  xl:w-28 2xl:m-auto px-1 py-1.5  ",
    width1: "text-red-500",
  },

  {
    title: " Address",
    key: "HealthCareProviderAddress_en",
    width: "md:w-24 lg:w-28  xl:w-44 2xl:m-auto px-1 py-1.5  mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Action",
    key: "action",
    width: "   px-1 py-1.5 ",
  },
];
const healthCareExportHeaders = [
  {
    title: "S.No.",
    key: "healthcareAutoUserId",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-24 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "MstHealthcareProviderId",
    key: "MstHealthcareProviderId",
    width: "md:w-20 lg:w-20  xl:w-28 2xl:28 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "HealthcareProviderDate",
    width: "md:w-20 lg:w-20  xl:w-28 2xl:28 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "HealthcareProviderName_en",
    key: "HealthcareProviderName_en",
    width: "md:w-28 lg:w-24  xl:w-44 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "HealthcareProviderName_ta",
    key: "HealthcareProviderName_en",
    width: "md:w-28 lg:w-24  xl:w-44 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "HealthcareProviderName_hi",
    key: "HealthcareProviderName_en",
    width: "md:w-28 lg:w-24  xl:w-44 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "HealthcareProviderName_mr",
    key: "HealthcareProviderName_en",
    width: "md:w-28 lg:w-24  xl:w-44 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "HealthcareProviderName_gu",
    key: "HealthcareProviderName_en",
    width: "md:w-28 lg:w-24  xl:w-44 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "HealthcareProviderName_kn",
    key: "HealthcareProviderName_en",
    width: "md:w-28 lg:w-24  xl:w-44 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "HealthcareProviderName_ml",
    key: "HealthcareProviderName_en",
    width: "md:w-28 lg:w-24  xl:w-44 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "HealthcareProviderName_te",
    key: "HealthcareProviderName_en",
    width: "md:w-28 lg:w-24  xl:w-44 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "HealthcareProviderName_bn",
    key: "HealthcareProviderName_en",
    width: "md:w-28 lg:w-24  xl:w-44 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "HealthcareProviderName_or",
    key: "HealthcareProviderName_en",
    width: "md:w-28 lg:w-24  xl:w-44 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Speciality_en",
    key: "Speciality_en",
    width: "md:w-24 lg:w-24  xl:w-36 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Speciality_ta",
    key: "Speciality_en",
    width: "md:w-24 lg:w-24  xl:w-36 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Speciality_hi",
    key: "Speciality_en",
    width: "md:w-24 lg:w-24  xl:w-36 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Speciality_mr",
    key: "Speciality_en",
    width: "md:w-24 lg:w-24  xl:w-36 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Speciality_gu",
    key: "Speciality_en",
    width: "md:w-24 lg:w-24  xl:w-36 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Speciality_kn",
    key: "Speciality_en",
    width: "md:w-24 lg:w-24  xl:w-36 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Speciality_ml",
    key: "Speciality_en",
    width: "md:w-24 lg:w-24  xl:w-36 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Speciality_te",
    key: "Speciality_en",
    width: "md:w-24 lg:w-24  xl:w-36 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Speciality_bn",
    key: "Speciality_en",
    width: "md:w-24 lg:w-24  xl:w-36 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Speciality_or",
    key: "Speciality_en",
    width: "md:w-24 lg:w-24  xl:w-36 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Email",
    key: "HealthcareProviderEmail",
    width: "md:w-32 lg:w-28  xl:w-52 2xl:m-auto  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Phone Number",
    key: "HealthcareProviderPhoneNo",
    width: "md:w-28 lg:w-24  xl:w-44 2xl:m-auto px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "State",
    key: "StateName_en",
    width: "md:w-28 lg:w-24  xl:w-44 2xl:m-auto px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Branch/Project",
    key: "LocationName_en",
    width: "md:w-28 lg:w-24  xl:w-44 2xl:m-auto px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "S.D.P.",
    key: "SDP_en",
    width: "md:w-28 lg:w-24  xl:w-44 2xl:m-auto px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Area",
    key: "AreaName_en",
    width: "md:w-28 lg:w-24  xl:w-44 2xl:m-auto px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Zip/Pincode",
    key: "HealthCarePinCode",
    width: "md:w-28 lg:w-24  xl:w-44 2xl:m-auto px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "HealthCareProviderAddress_en",
    key: "HealthCareProviderAddress_en",
    width: "md:w-24 lg:w-28  xl:w-44 2xl:m-auto px-1 py-1.5  mr-auto",
    width1: "text-red-500",
  },

  {
    title: "HealthCareProviderAddress_ta",
    key: "HealthCareProviderAddress_en",
    width: "md:w-24 lg:w-28  xl:w-44 2xl:m-auto px-1 py-1.5  mr-auto",
    width1: "text-red-500",
  },
  {
    title: "HealthCareProviderAddress_hi",
    key: "HealthCareProviderAddress_en",
    width: "md:w-24 lg:w-28  xl:w-44 2xl:m-auto px-1 py-1.5  mr-auto",
    width1: "text-red-500",
  },
  {
    title: "HealthCareProviderAddress_mr",
    key: "HealthCareProviderAddress_en",
    width: "md:w-24 lg:w-28  xl:w-44 2xl:m-auto px-1 py-1.5  mr-auto",
    width1: "text-red-500",
  },
  {
    title: "HealthCareProviderAddress_gu",
    key: "HealthCareProviderAddress_en",
    width: "md:w-24 lg:w-28  xl:w-44 2xl:m-auto px-1 py-1.5  mr-auto",
    width1: "text-red-500",
  },

  {
    title: "HealthCareProviderAddress_kn",
    key: "HealthCareProviderAddress_en",
    width: "md:w-24 lg:w-28  xl:w-44 2xl:m-auto px-1 py-1.5  mr-auto",
    width1: "text-red-500",
  },
  {
    title: "HealthCareProviderAddress_ml",
    key: "HealthCareProviderAddress_en",
    width: "md:w-24 lg:w-28  xl:w-44 2xl:m-auto px-1 py-1.5  mr-auto",
    width1: "text-red-500",
  },

  {
    title: "HealthCareProviderAddress_te",
    key: "HealthCareProviderAddress_en",
    width: "md:w-24 lg:w-28  xl:w-44 2xl:m-auto px-1 py-1.5  mr-auto",
    width1: "text-red-500",
  },
  {
    title: "HealthCareProviderAddress_bn",
    key: "HealthCareProviderAddress_en",
    width: "md:w-24 lg:w-28  xl:w-44 2xl:m-auto px-1 py-1.5  mr-auto",
    width1: "text-red-500",
  },
  {
    title: "HealthCareProviderAddress_or",
    key: "HealthCareProviderAddress_en",
    width: "md:w-24 lg:w-28  xl:w-44 2xl:m-auto px-1 py-1.5  mr-auto",
    width1: "text-red-500",
  },
  // {
  //   title: "Photo",
  //   key: "HealthCareProviderPhoto",
  //   width: "   px-1 py-1.5 ",
  // },
  {
    title: "Created By",
    key: "FullName_en",
    width: "   px-1 py-1.5 ",
  },
];
const inventoryProductHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:w-12 px-1 py-1.5  ",

    width1: "text-red-500",
  },
  // {
  //   title: "Image",
  //   key: "ChooseFile",
  //   width: "md:w-18 2xl:w-12 px-1 py-1.5  ",
  //   width1: "text-red-400 ",
  // },
  {
    title: "Commodity Category",
    key: "GCategoriesType",
    width: "md:w-56 lg:w-60 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Commodity Name",
    key: "CommodityName_en",
    width: "md:w-44 lg:w-60 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Brand",
    key: "CommodityBrand_en",
    width:
      "md:w-32 lg:w-60 whitespace-normal break-words 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Description",
    key: "Description_en",
    width:
      "md:w-44 lg:w-60 whitespace-normal break-words 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "U.O.M",
    key: "GUOM",
    width: "md:w-20 2xl:w-40 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5 ",
  },
];

const schoolMasterHeaders = [
  {
    title: "S.No.",
    key: "MstSchoolId",
    width: "md:w-10 lg:w-12 xl:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "School / College Id",
    key: "SchoolId",
    width:
      "md:w-28 md:whitespace-pre-line whitespace-normal break-words lg:w-28 xl:w-40 2xl:m-auto  px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Name Of The School / College",
    key: "SchoolName",
    width:
      "md:w-44 md:whitespace-pre-line lg:w-44 xl:w-56 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Contact Person Name",
    key: "SchoolContactPerson",
    width:
      "md:w-28 md:whitespace-pre-line lg:w-28 xl:w-40 2xl:m-auto  px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Phone Number",
    key: "SchoolPhoneNumber",
    width:
      "md:w-24 md:whitespace-pre-line lg:w-24 xl:w-32 2xl:m-auto  px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Email Id",
    key: "SchoolEmail",
    width: "md:w-32 lg:w-24 xl:w-44 2xl:m-auto  px-1 py-1.5 mr-auto ",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5 ",
  },
];
const schoolMasterExportHeaders = [
  {
    title: "S.No.",
    key: "MstSchoolId",
    width: "md:w-10 lg:w-12 xl:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "MstSchoolId",
    key: "MstSchoolId",
    width: "md:w-10 lg:w-12 xl:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "School / College Id",
    key: "SchoolId",
    width:
      "md:w-28 md:whitespace-pre-line whitespace-normal break-words lg:w-28 xl:w-40 2xl:m-auto  px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Name Of The School / College",
    key: "SchoolName",
    width:
      "md:w-44 md:whitespace-pre-line lg:w-44 xl:w-56 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "State",
    key: "StateName_en",
    width: " px-1 py-1.5 ",
  },
  {
    title: "Branch/Project",
    key: "LocationName_en",
    width: " px-1 py-1.5 ",
  },
  {
    title: "Place",
    key: "SchoolVenue",
    width: " px-1 py-1.5 ",
  },
  {
    title: "Contact Person Name",
    key: "SchoolContactPerson",
    width:
      "md:w-28 md:whitespace-pre-line lg:w-28 xl:w-40 2xl:m-auto  px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "School / College Address",
    key: "SchoolAddress",
    width: " px-1 py-1.5 ",
  },
  {
    title: "Mobile Number",
    key: "SchoolPhoneNumber",
    width:
      "md:w-24 md:whitespace-pre-line lg:w-24 xl:w-32 2xl:m-auto  px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Email Id",
    key: "SchoolEmail",
    width: "md:w-32 lg:w-24 xl:w-44 2xl:m-auto  px-1 py-1.5 mr-auto ",
    width1: "text-red-500",
  },
  {
    title: "Remarks",
    key: "SchoolRemarks",
    width: " px-1 py-1.5 ",
  },
  {
    title: "Created By",
    key: "FullName_en",
    width: " px-1 py-1.5 ",
  },
];
const youthGroupMasterHeaders = [
  {
    title: "S.No.",
    key: "MstYouthGroupId",
    width: "md:w-10 lg:w-10 xl:w-12 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Youth GroupId",
    key: "YouthGroupId",
    width:
      "md:w-40 lg:w-40 whitespace-pre-line xl:w-40 2xl:m-auto px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Youth Group Name",
    key: "YouthGroupName",
    width:
      "md:w-40 lg:w-40 whitespace-pre-line xl:w-56 2xl:m-auto px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Youth Volunteer Name",
    key: "YouthVolunteerName",
    width:
      "md:w-36 lg:w-36 whitespace-pre-line xl:w-40 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Mobile Number",
    key: "YouthGroupPhoneNumber",
    width: "md:w-28 lg:w-28 xl:w-32 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Email Id",
    key: "YouthGroupEmail",
    width: "md:w-28 lg:w-28 xl:w-44 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5",
  },
];
const youthGroupMasterExportHeaders = [
  {
    title: "S.No.",
    key: "MstYouthGroupId",
    width: "md:w-10 lg:w-10 xl:w-12 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "MstYouthGroupId",
    key: "MstYouthGroupId",
    width:
      "md:w-40 lg:w-40 whitespace-pre-line xl:w-40 2xl:m-auto px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "Date",
    width:
      "md:w-40 lg:w-40 whitespace-pre-line xl:w-40 2xl:m-auto px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Youth Group Id",
    key: "YouthGroupId",
    width:
      "md:w-40 lg:w-40 whitespace-pre-line xl:w-40 2xl:m-auto px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Youth Group Name",
    key: "YouthGroupName",
    width:
      "md:w-40 lg:w-40 whitespace-pre-line xl:w-56 2xl:m-auto px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Type Of Group",
    key: "TypeOfGroupName",
    width: "px-1 py-1.5",
  },
  {
    title: "State",
    key: "StateName_en",
    width: "px-1 py-1.5",
  },
  {
    title: "Branch/Project",
    key: "LocationName_en",
    width: "px-1 py-1.5",
  },
  {
    title: "Place",
    key: "YouthGroupVenue",
    width: "px-1 py-1.5",
  },
  {
    title: "Youth Volunteer Name",
    key: "YouthVolunteerName",
    width:
      "md:w-36 lg:w-36 whitespace-pre-line xl:w-40 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Mobile Number",
    key: "YouthGroupPhoneNumber",
    width: "md:w-28 lg:w-28 xl:w-32 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Email Id",
    key: "YouthGroupEmail",
    width: "md:w-28 lg:w-28 xl:w-44 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Remarks",
    key: "YouthGroupRemarks",
    width: "px-1 py-1.5",
  },
  {
    title: "Created By",
    key: "FullName_en",
    width: "px-1 py-1.5",
  },
];
const studentMasterHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:flex-1 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },

  {
    title: "School Name",
    key: "SchoolName",
    width:
      "md:w-60 whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Student Name",
    key: "StudentName",
    width: "md:w-36 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Student ID",
    key: "StudentId",
    width: "md:w-32 2xl:flex-1 px-1 py-1.5 m-auto ",
    width1: "text-red-500",
  },
  {
    title: "Class",
    key: "StudentClass",
    width: "md:w-24 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Division",
    key: "StudentDivision",
    width: "md:w-24 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Gender / Age",
    key: "GenderAge",
    width: "md:w-32 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "Action",
    key: "action",
    width: " 2xl:flex-1  px-1 py-1.5 m-auto",
  },
];
const appointmentHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Client Name",
    key: "appointmentClient",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Service",
    key: "appointmentService",
    width: "md:w-44 2xl:flex-1 whitespace-normal break-words px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "appointmentDate",
    width: "md:w-32 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Time",
    key: "appointmentTime",
    width: "md:w-24 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Appointment Type",
    key: "appointmentType",
    width: "md:w-32 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "HCP Name",
    key: "appointmentHCP",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Action",
    key: "action",
    width: " 2xl:flex-1  px-1 py-1.5 ",
  },
];

const eventMasterHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:flex-1 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "Event Number",
    key: "EventNumber",
    width: "md:w-32 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-400",
    width1: "text-red-500",
  },

  {
    title: "Session Type",
    key: "GEventType",
    width: "md:w-32 2xl:flex-1 px-1 py-1.5 m-auto ",
    filterInputBox: "block text-sm text-red-400 mt-2 w-28 h-6",
    width1: "text-red-500",
  },
  {
    title: "School ID",
    key: "GEventSchoolId",
    width: "md:w-32 2xl:flex-1 px-1 py-1.5 m-auto",
    filterInputBox: "block text-sm text-red-400 mt-2 w-28 h-6",
    width1: "text-red-500",
  },
  {
    title: "Session Date",
    key: "EventDate",
    width: "md:w-32 2xl:flex-1 px-1 py-1.5 m-auto",
    filterInputBox: "block text-sm text-red-400 mt-2 w-28 h-6",
    width1: "text-red-500",
  },
  {
    title: "From",
    key: "EventFrom",
    width: "md:w-28 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "To",
    key: "EventTo",
    width: "md:w-28 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Address",
    key: "EventAddress",
    width: " 2xl:flex-1  px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " 2xl:flex-1  px-1 py-1.5 m-auto",
  },
];
const EducationMaterialMasterHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Material Title",
    key: "materialTitle",
    width:
      "md:w-44 whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Material Subject",
    key: "materialSubject",
    width:
      "md:w-48 whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Material Type",
    key: "materialType",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Remarks",
    key: "remarks",
    width: "md:w-40 2xl:flex-1 px-1 py-1.5 m-auto ",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "2xl:flex-1  px-1 py-1.5 m-auto",
  },
];
const cseInSchoolHeaders = [
  {
    title: "S.No.",
    key: "Sno",
    width: "md:w-10 xl:w-10 2xl:w-10 px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "OldDate",
    width: "sm:w-20 md:w-20 lg:w-20 xl:20 2xl:w-20 px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "School Name",
    key: "SchoolName",
    width: "sm:w-20 md:w-52 lg:w-52 xl:w-80 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Class",
    key: "GridTableClass",
    width: "md:w-12 xl:w-32 2xl:w-16 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Division",
    key: "Division",
    width: "md:w-16 xl:w-16 2xl:w-16 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Sessions",
    key: "Sessions",
    width: "md:w-16 lg:w-16 xl:w-16 2xl:w-16 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "schoolAction",
    width: " px-1 py-1.5",
  },
];

const inschoolsessionStudentHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5",
  },
  {
    title: "Roll No.",
    key: "RollId",
    width: "md:w-32  2xl:w-72 whitespace-normal break-words  px-1 py-1.5 ",
  },
  {
    title: "Student Name",
    key: "StudentName",
    width:
      "md:w-32 xl:w-44 2xl:w-72 whitespace-normal break-words  px-1 py-1.5 ",
  },
  {
    title: "Last Session Date",
    key: "LastDate",
    width: "md:w-32  2xl:w-72 whitespace-normal break-words  px-1 py-1.5 ",
  },
  {
    title: "Gender / Age",
    key: "GenderAge",
    width: "md:w-32  2xl:w-72 whitespace-normal break-words  px-1 py-1.5 ",
  },
  {
    title: "Referral Service",
    key: "ReferralServices",
    width:
      "md:w-32 xl:w-48 2xl:w-72 whitespace-normal break-words  px-1 py-1.5 ",
  },
  {
    title: "Referred To",
    key: "ReferredTo_en",
    width:
      "md:w-32 xl:w-44 2xl:w-72 whitespace-normal break-words  px-1 py-1.5 ",
  },
  {
    title: "Modules",
    key: "Modules",
    width: "md:w-32  2xl:w-72 whitespace-normal break-words  px-1 py-1.5 ",
  },
];
const outOfSchoolYouthHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5",
  },
  {
    title: "Youth Name",
    key: "YouthName",
    width:
      "md:w-32 xl:w-36 2xl:w-72 whitespace-normal break-words  px-1 py-1.5 ",
  },
  {
    title: "Youth Id",
    key: "YouthId",
    width: "md:w-32  2xl:w-72 whitespace-normal break-words  px-1 py-1.5 ",
  },
  {
    title: "Last Session Date",
    key: "LastDate",
    width: "md:w-28  2xl:w-72 whitespace-normal break-words  px-1 py-1.5 ",
  },
  {
    title: "Gender / Age",
    key: "GenderAge",
    width: "md:w-28 2xl:w-72 whitespace-normal break-words  px-1 py-1.5 ",
  },
  {
    title: "Referral Service",
    key: "ReferralServices",
    width:
      "md:w-32 xl:w-40 2xl:w-72 whitespace-normal break-words  px-1 py-1.5 ",
  },
  {
    title: "Referred To",
    key: "ReferredTo_en",
    width:
      "md:w-32 xl:w-40 2xl:w-72 whitespace-normal break-words  px-1 py-1.5 ",
  },
  {
    title: "Modules",
    key: "Modules",
    width: "md:w-32  2xl:w-72 whitespace-normal break-words  px-1 py-1.5 ",
  },
];
const cseOutSchoolHeaders = [
  {
    title: "S.No.",
    key: "Sno",
    width: "md:w-10 2xl:w-10 px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "OldDate",
    width: "md:w-20 xl:20 2xl:w-20 px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Youth Group Name",
    key: "YouthGroupName",
    width: "md:w-72 xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Sessions",
    key: "Sessions",
    width: "md:w-20 2xl:w-20 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "schoolAction",
    width: "px-1 py-1.5",
  },
];
const cseHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:flex-1 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "Type",
    key: "type",
    width: "md:w-20 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "School / Youth Group Name",
    key: "schoolName",
    width:
      "md:w-52  whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Student / Youth Name",
    key: "studentName",
    width:
      "md:w-48 whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Event Number",
    key: "eventNumber",
    width:
      "md:w-32 whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 m-auto ",
    width1: "text-red-500",
  },
  {
    title: "Module",
    key: "module",
    width:
      "md:w-36 whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Remarks",
    key: "remarks",
    width:
      "md:w-36 whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " 2xl:flex-1  px-1 py-1.5 m-auto",
  },
];
const inventoryReceiptsHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-10 2xl:w-12  px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Receipt No.",
    key: "ReceiptNo",
    width: "md:w-28 lg:w-28 xl:w-44 2xl:flex-1 px-1 py-1.5 ",
  },
  {
    title: "Date",
    key: "FormattedReceiptDate",
    width: "md:w-28 lg:w-28 xl:w-40 2xl:flex-1 px-1 py-1.5 ",
  },
  {
    title: "From",
    key: "ReceivedFrom_en",
    width:
      "md:w-32 lg:w-32 xl:w-44 whitespace-pre-line 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Name",
    key: "FromName",
    width:
      "md:w-32 lg:w-32 xl:w-44 2xl:flex-1 whitespace-pre-line px-1 py-1.5 ",
  },
  {
    title: "Received By",
    key: "ReceiptReceivedBy_en",
    width: "md:w-28 lg:w-28 xl:w-40 2xl:flex-1 2xl:flex-1 px-1 py-1.5  mr-auto",
  },
  {
    title: "Action",
    key: "receiptAction",
    width: "md:w-28    px-1 py-1.5 ",
  },
];
const inventoryReceiptsViewHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-10 2xl:w-12 px-1 py-1.5 ",
  },
  {
    title: "Receipt No.",
    key: "ReceiptNo",
    width:
      "md:w-20 lg:w-20 xl:w-24 2xl:flex-1 whitespace-pre-line px-1 py-1.5 ",
  },
  {
    title: "Date",
    key: "FormattedReceiptDate",
    width:
      "md:w-20 lg:w-20 xl:w-24 2xl:flex-1 whitespace-pre-line px-1 py-1.5 ",
  },
  {
    title: "Category",
    key: "CommodityCategory_en",
    width: "md:w-20 lg:w-20 xl:w-32 2xl:flex-1 whitespace-pre-line px-1 py-1.5",
  },
  {
    title: "Name",
    key: "CommodityName_en",
    width: "md:w-20 lg:w-20 xl:w-32 2xl:flex-1 whitespace-pre-line px-1 py-1.5",
  },
  {
    title: "Brand",
    key: "BrandName",
    width:
      "md:w-20 lg:w-20 xl:w-32 2xl:flex-1 whitespace-pre-line  px-1 py-1.5 ",
  },
  {
    title: "Qty.",
    key: "ReceiptQuantity",
    width:
      "md:w-12 lg:w-12 xl:w-20 2xl:flex-1 whitespace-pre-line px-1 py-1.5 ",
  },
  {
    title: "U.O.M.",
    key: "ReceiptUOM",
    width:
      "md:w-12 lg:w-12 xl:w-20 2xl:flex-1 whitespace-pre-line px-1 py-1.5 ",
  },
  {
    title: "Batch No.",
    key: "ReceiptBatchNo",
    width:
      "md:w-20 lg:w-20 xl:w-20 2xl:flex-1 whitespace-pre-line px-1 py-1.5 ",
  },
  {
    title: "Date Of Expiry",
    key: "FormattedReceiptDateOfExpiry1",
    width:
      "md:w-20 lg:w-20 xl:w-32 2xl:flex-1 whitespace-pre-line px-1 py-1.5 mr-auto",
  },
  {
    title: "Rate",
    key: "ReceiptRate",
    width: "md:w-14 px-1 py-1.5 ",
  },
];
const SRHCommoditiesMasterHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:flex-1 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "Category",
    key: "category",
    width: "md:w-40 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Service List",
    key: "serviceList",
    width:
      "md:w-44 whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Commodities",
    key: "commodities",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Description",
    key: "description",
    width:
      "md:w-40 whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 m-auto ",
    width1: "text-red-500",
  },
  {
    title: "Unit Of Measure",
    key: "unitOfMeasure",
    width: "md:w-36 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " 2xl:flex-1  px-1 py-1.5 m-auto",
  },
];
const NonSRHProductsMasterHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:flex-1 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "Commodities",
    key: "commodities",
    width: "md:w-36 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Description",
    key: "description",
    width:
      "md:w-60 whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 m-auto ",
    width1: "text-red-500",
  },
  {
    title: "Unit Of Measure",
    key: "unitOfMeasure",
    width: "md:w-32 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " 2xl:flex-1  px-1 py-1.5 m-auto",
  },
];
const spServiceSessionMasterHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "Date",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:w-24 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Venue",
    key: "Venue_en",
    width: "md:w-32 lg:w-32 xl:w-52 2xl:w-52 whitespace-pre-line px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Special Service Session Type",
    key: "SPServicesName_en",
    width: "md:w-48 lg:w-52 xl:w-80 whitespace-pre-line 2xl:w-80 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Client Type",
    key: "ClientType_en",
    width: "md:w-40 lg:w-52 xl:w-80 2xl:w-80 whitespace-pre-line px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Healthcare Provider Name",
    key: "HealthcareProviderName_en",
    width:
      "md:w-44 lg:w-52 xl:w-80 2xl:w-80 whitespace-pre-line px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5 ",
  },
];
const ServicesClientHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Client Reg. Dt.",
    key: "FormattedDate",
    width: "md:w-24 lg:w-24 whitespace-normal break-words px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Client Id",
    key: "ClientId",
    width: "md:w-32 lg:w-32 xl:w-64 2xl:w-72  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Ex. Client Id",
    key: "ClientExistingClientId",
    width: "md:w-28 lg:w-24 xl:w-32 2xl:w-72  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Client Name",
    key: "ClientName_en",
    width: "md:w-36 lg:w-36 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Mother's Name",
    key: "ClientMotherName_en",
    width: "md:w-32 lg:w-36 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Gender / Age",
    key: "ClientGenderAge_en",
    width: "md:w-24 2xl:w-44 lg:w-24 whitespace-pre-line  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Phone",
    key: "GridClientPhoneNo",
    width: "md:w-28 lg:w-28 2xl:w-52  px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Staff Name",
    key: "UserName_en",
    width: "md:w-28 lg:w-28 xl:w-44 2xl:w-72  px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "ServicesClientAction",
    width: "w-20 px-1 py-1.5",
  },
];
const ServicesHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Service Prv. Dt.",
    key: "FormattedDate",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:w-24 whitespace-pre-line px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Client Id",
    key: "ServicesId",
    width: "md:w-60 lg:w-60 xl:w-72 2xl:w-60 whitespace-pre-line px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Client Name",
    key: "ClientName_en",
    width: "md:w-52 lg:w-52 xl:w-72 2xl:w-96 whitespace-pre-line px-1 py-1.5",
    width1: "text-red-500",
  },

  {
    title: "C.R.Supply Follow Up",
    key: "CRSFollowUp1",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:w-24 whitespace-pre-line px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Referral Follow Up",
    key: "ReferralFollowUp1",
    width:
      "md:w-24 lg:w-24 xl:w-24 2xl:w-24 whitespace-pre-line px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action1",
    width: " px-1 py-1.5 ",
  },
];
const ServicesAddHeader = [
  {
    title: "Services",
    key: "value",
    width: "md:w-60 2xl:w-96 truncate  px-1 py-1.5 m-auto",
  },

  {
    title: "Test Result",
    key: "test",
    width: "md:w-28 px-1 py-1.5 m-auto text-center",
  },
  {
    title: "UOM",
    key: "uom",
    width: "md:w-20 px-2 py-3 m-auto text-center",
  },
  {
    title: "PAC Services",
    key: "pacservices",
    width: "md:w-32 px-2 py-3 text-center m-auto",
  },
  {
    title: "Brand",
    key: "brand",
    width: "md:w-32 px-2 py-3 text-center m-auto",
  },
  {
    title: "Item",
    key: "qty",
    width: "md:w-20 px-1 py-1.5 text-center m-auto",
  },

  {
    title: "Charges",
    key: "servicesCharge",
    width: "md:w-24 px-2 py-3 text-center m-auto",
  },
  {
    title: "F.P. User",
    key: "FPUser",
    width: "md:w-32 px-2 py-3 text-center m-auto",
  },

  {
    title: "Referred To",
    key: "referral",
    width: "md:w-36 px-1 py-1.5 m-auto text-center",
  },
  {
    title: "Action",
    key: "ServicesAction",
    width: "px-1 py-1.5 text-center m-auto",
  },
];
const ServicesAddViewHeader = [
  {
    title: "Services",
    key: "value",
    width: "md:w-60 2xl:w-96 truncate  px-1 py-1.5 m-auto",
  },

  {
    title: "Test Result",
    key: "test",
    width: "md:w-28 px-1 py-1.5 m-auto text-center",
  },
  {
    title: "UOM",
    key: "uom",
    width: "md:w-16 px-1 py-1.5 m-auto text-center",
  },
  {
    title: "Item",
    key: "qty",
    width: "md:w-20 px-1 py-1.5 text-center m-auto",
  },
  {
    title: "PAC Services",
    key: "pacservices",
    width: "md:w-32 px-2 py-3 text-center m-auto",
  },
  {
    title: "Brand",
    key: "brand",
    width: "md:w-36 px-1 py-1.5 text-center m-auto",
  },
  {
    title: "Charges",
    key: "servicesCharge",
    width: "md:w-20 px-1 py-1.5 text-center m-auto",
  },
  {
    title: "F.P. User",
    key: "FPUser",
    width: "md:w-36 px-1 py-1.5 text-center m-auto",
  },
  {
    title: "Referred To",
    key: "referral",
    width: "md:w-36 px-1 py-1.5 m-auto text-center",
  },
];
const ServicesHeadersData = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:w-12 lg:w-12 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "FormattedDate",
    width: "md:w-24 2xl:w-24 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "S.D.P",
    key: "SDP_en",
    width: "md:w-40 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Services",
    key: "Services_en",
    width: "md:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "detailsAction",
    width: "md:w-40 text-center 2xl:flex-1 px-1 py-1.5 ",
  },
];

const inventoryIndentHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:flex-1 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "FormattedIndentDate",
    width:
      "md:w-32  whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Indent",
    key: "IndentFrom1_en",
    width:
      "md:w-32  whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 m-auto ",
    width1: "text-red-500",
  },
  {
    title: "Name",
    key: "IndentFrom2_en",
    width:
      "md:w-40  whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "Action",
    key: "action",
    width: " 2xl:flex-1  px-1 py-1.5 m-auto",
  },
];
const ResourcesMasterHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-20  px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Photo",
    key: "ResourcesPhoto",
    width: "md:w-44  whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Resource Person Name",
    key: "ResourcesName",
    width: "md:w-72  whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Position",
    key: "ResourcesPosition",
    width: "md:w-60  whitespace-normal break-words 2xl:flex-1 px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Branch/Project",
    key: "LocationName_en",
    width:
      "md:w-52  whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 mr-auto ",
    width1: "text-red-500",
  },

  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5 ",
  },
];
const ResourcesMasterExportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-20  px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "MstResourcesId",
    key: "MstResourcesId",
    width: "md:w-72  whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Resource Person Name",
    key: "ResourcesName",
    width: "md:w-72  whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Position",
    key: "ResourcesPosition",
    width: "md:w-60  whitespace-normal break-words 2xl:flex-1 px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "State",
    key: "StateName_en",
    width: "md:w-44  whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Branch/Project",
    key: "LocationName_en",
    width:
      "md:w-52  whitespace-normal break-words 2xl:flex-1 px-1 py-1.5 mr-auto ",
    width1: "text-red-500",
  },

  {
    title: "Created By",
    key: "FullName_en",
    width: " px-1 py-1.5 ",
  },
];
const studentDetailsHeaders = [
  {
    title: "S.No.",
    key: "no",
    width: "md:w-12 2xl:flex-1 px-1 py-1.5  m-auto",
  },
  {
    title: "Student Name",
    key: "StudentName",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Student ID",
    key: "StudentId",
    width: "md:w-24 2xl:flex-1 px-1 py-1.5 m-auto ",
    width1: "text-red-500",
  },
  {
    title: "Gender / Age",
    key: "StudentAge",
    width: "md:w-28 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Class",
    key: "StudentClass",
    width: "md:w-20 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Division",
    key: "StudentDivision",
    width: "md:w-20 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Referel Service",
    key: "ReferalService",
    width: "md:w-36 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Refered to",
    key: "ReferedTo",
    width: "md:w-36 2xl:flex-1 px-1 py-1.5 m-auto",
  },
];
const BrochureMasterHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 2xl:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Image",
    key: "NewVariable",
    key1: "BrochureType",
    width:
      "md:w-32 lg:w-28 xl:w-32 2xl:w-28 whitespace-normal break-words px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Brochure Name",
    key: "BrochureName",
    width: "whitespace-normal break-words flex-1 px-1 py-1.5 m-auto ",

    width1: "text-red-500",
  },
  {
    title: "Brochure Type",
    key: "BrochureTypes",
    width: "whitespace-normal break-words flex-1 px-1 py-1.5 m-auto ",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "  px-1 py-1.5 m-auto",
  },
];
const BrochureMasterExportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 2xl:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "MstBrochureId",
    key: "MstBrochureId",
    width:
      "md:w-32 lg:w-28 xl:w-32 2xl:w-28 whitespace-normal break-words px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Brochure Type",
    key: "BrochureTypes",
    width:
      "md:w-32 lg:w-28 xl:w-32 2xl:w-28 whitespace-normal break-words px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Topics",
    key: "IECTopic_en",
    width:
      "md:w-32 lg:w-28 xl:w-32 2xl:w-28 whitespace-normal break-words px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Language",
    key: "Language",
    width:
      "md:w-32 lg:w-28 xl:w-32 2xl:w-28 whitespace-normal break-words px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Brochure Name",
    key: "BrochureName",
    width: "whitespace-normal break-words flex-1 px-1 py-1.5 m-auto ",

    width1: "text-red-500",
  },
  {
    title: "Created By",
    key: "FullName_en",
    width: "whitespace-normal break-words flex-1 px-1 py-1.5 m-auto ",
    width1: "text-red-500",
  },
];
const AwarenessHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-20 2xl:w-12 px-1 py-1.5  ",
  },
  {
    title: "Date",
    key: "AwarenessDate",
    width: "md:w-36 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Awareness Type",
    key: "AwarenessType",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  // {
  //   title: "Category",
  //   key: "AwarenessCategory",
  //   width: "md:w-40 2xl:flex-1 px-1 py-1.5 ",
  // },
  {
    title: "Topics",
    key: "AwarenessTopics",
    width: "md:w-52 whitespace-pre-line 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Remarks",
    key: "AwarenessRemarks",
    width: "md:w-96 whitespace-pre-line 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5 ",
  },
];
const YouthHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:w-12 px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Youth Group Name",
    key: "YouthGroupName",
    width: "md:w-64 whitespace-pre-line 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Name",
    key: "YouthName",
    width: "md:w-36 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Youth ID",
    key: "YouthId",
    width: "md:w-32 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Gender / Age",
    key: "GenderAge",
    width: "md:w-32 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Remarks",
    key: "YouthRemarks",
    width: "md:w-64  whitespace-pre-line 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5 ",
  },
];
const roleVsCapabilityHeader = [
  // {
  //   title: "S.No.",
  //   key: "sno",
  //   width: "md:w-20 2xl:w-12 px-1 py-1.5  ",
  // },
  {
    title: "Select All Menus",
    key: "MenuName",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Rights",
    key: "Rights",
    width: "md:w-96 whitespace-pre-line 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
];

const eventRegisterHeaders = [
  {
    title: "S.No.",
    key: "TxnEventRegisterId",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-14 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Month",
    key: "MonthName",
    width: "md:w-32 2xl:m-auto  px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Year",
    key: "YearId",
    width: "md:w-28 lg:w-28 whitespace-break-spaces 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Teacher Training",
    key: "TeacherTraining",
    width:
      "md:w-40 2xl:w-40 lg:w-44  whitespace-break-spaces 2xl:m-auto px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "NGO/CBO Staff Training",
    key: "NGOCBOStaffTraining",
    width: "md:w-52 lg:w-60 whitespace-break-spaces 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "PE Training",
    key: "PeerEducatorTrained",
    width:
      "md:w-40 lg:w-40 whitespace-break-spaces lg:w-60 2xl:w-96 2xl:m-auto  px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Peer-To-Peer Training",
    key: "PeerToPeerTraining",
    width:
      "md:w-52 lg:w-60 2xl:w-96 whitespace-break-spaces px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5",
  },
];

const InterPersonalContactHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-10 2xl:w-10 px-1 py-1.5  ",
  },
  {
    title: "Date",
    key: "Date",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:w-24 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Locality / Street",
    key: "LocalityStreet_en",
    width: "md:w-40 lg:w-40 xl:w-44 2xl:w-52 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Topic",
    key: "IECTopic_en",
    width: "md:w-48 lg:w-48 xl:w-72 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Staff Name",
    key: "StaffName_en",
    width: "md:w-32 lg:w-32 xl:w-52 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5 ",
  },
];
const GroupDiscussionHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-10 2xl:w-10 px-1 py-1.5  ",
  },
  {
    title: "Date",
    key: "Date",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:w-24 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Venue",
    key: "Venue_en",
    width: "md:w-36 lg:w-40 xl:w-44 2xl:w-52 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Topic",
    key: "IECTopic_en",
    width: "md:w-44 lg:w-48 xl:w-72 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Staff Name",
    key: "StaffName_en",
    width: "md:w-32 lg:w-32 xl:w-52 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5 ",
  },
];

const GeneralMassMeetingHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-10 2xl:w-10 px-1 py-1.5  ",
  },
  {
    title: "Date",
    key: "Date",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:w-24 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Venue",
    key: "Venue_en",
    width: "md:w-36 lg:w-40 xl:w-44 2xl:w-52 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Topic",
    key: "IECTopic_en",
    width: "md:w-44 lg:w-48 xl:w-72 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Staff Name",
    key: "StaffName_en",
    width: "md:w-32 lg:w-32 xl:w-52 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5 ",
  },
];

const MassMediaHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-10 2xl:w-10 px-1 py-1.5  ",
  },
  {
    title: "Date",
    key: "Date",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:w-24 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Venue",
    key: "Venue_en",
    width: "md:w-40 lg:w-40 xl:w-52 2xl:w-52 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Topic",
    key: "IECTopic_en",
    width: "md:w-44 lg:w-60 xl:w-80 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5 ",
  },
];

const SpecialServiceSessionHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-14 lg:w-12 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Client Id",
    key: "clientId",
    width: "md:w-32 lg:w-32 xl:w-60 2xl:m-auto  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Client Name",
    key: "clientName",
    width: "md:w-32 lg:w-36 xl:w-60 2xl:m-auto  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Mother's Name",
    key: "clientMotherName",
    width: "md:w-32 lg:w-32 xl:w-60 2xl:m-auto  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Gender / Age",
    key: "clientGender",
    width: "md:w-32 lg:w-28 xl:w-32 2xl:m-auto  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Phone",
    key: "clientPhone",
    width: "md:w-32 lg:w-28 xl:w-48 2xl:m-auto  px-1 py-1.5",
    width1: "text-red-500",
  },
  // {
  //   title: "Address",
  //   key: "address",
  //   width: "md:w-20 whitespace-normal break-words lg:w-32 2xl:w-40 px-1 py-1.5",
  // },
  {
    title: "Action",
    key: "SplServiceAction",
    width: " px-1 py-1.5  ",
  },
];
const ConsumptionViewHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-10 2xl:w-12 px-1 py-1.5 ",
  },
  {
    title: "Consumption No.",
    key: "ConsumptionNo",
    width:
      "md:w-24 lg:w-24 xl:w-24 2xl:flex-1 whitespace-pre-line px-1 py-1.5 ",
  },
  {
    title: "Date",
    key: "FormattedConsumptionDate",
    width:
      "md:w-20 lg:w-20 xl:w-20 2xl:flex-1 whitespace-pre-line px-1 py-1.5 ",
  },
  {
    title: "Category",
    key: "CommodityCategory_en",
    width: "md:w-20 lg:w-24 xl:w-32 2xl:flex-1 whitespace-pre-line px-1 py-1.5",
  },
  {
    title: "Name",
    key: "CommodityName_en",
    width: "md:w-20 lg:w-20 xl:w-32 2xl:flex-1 whitespace-pre-line px-1 py-1.5",
  },
  {
    title: "Brand",
    key: "Brand_en",
    width:
      "md:w-20 lg:w-20 xl:w-32 2xl:flex-1 whitespace-pre-line  px-1 py-1.5 ",
  },
  {
    title: "Demo.",
    key: "Demonstration",
    width:
      "md:w-12 lg:w-12 xl:w-20 2xl:flex-1 whitespace-pre-line px-1 py-1.5 ",
  },
  {
    title: "Damaged/Adjustments",
    key: "DamagedAdjustments",
    width:
      "md:w-12 lg:w-12 xl:w-24 2xl:flex-1  whitespace-pre-line break-words px-1 py-1.5 ",
  },
  {
    title: "Exp.",
    key: "Expired",
    width:
      "md:w-12 lg:w-12 xl:w-20 2xl:flex-1 whitespace-pre-line px-1 py-1.5 mr-auto",
  }, {
    title: "Clients",
    key: "Clients",
    width:
      "md:w-12 lg:w-12 xl:w-20 2xl:flex-1 whitespace-pre-line px-1 py-1.5 mr-auto",
  },
  // {
  //   title: "Assoc. Clinic",
  //   key: "GivenToAssociatedClinics",
  //   width:
  //     "md:w-20 lg:w-20 xl:w-32 2xl:flex-1 whitespace-pre-line px-1 py-1.5 mr-auto",
  // },
  {
    title: "Total",
    key: "Total",
    width: "md:w-14 px-1 py-1.5 ",
  },
];
const ServicesName = [
  { value: "1", label: "Family Planning" },
  { value: "2", label: "Abortion" },
  { value: "3", label: "HIV/AIDS" },
  { value: "4", label: "STI/RTI" },
  { value: "5", label: "Gynaecology" },
  { value: "6", label: "ANC/PNC" },
  { value: "7", label: "Urology" },
  { value: "8", label: "Subfertility" },
  { value: "9", label: "Specialized SRH" },
  { value: "10", label: "Paediatrics" },
  { value: "11", label: "Other SRH" },
  { value: "12", label: "Non-SRH" },
];
const ReferedTo = [
  { value: "1", label: "Static Clinic" },
  { value: "2", label: "Satelite Clinic" },
  { value: "3", label: "Mobile clinic" },
  { value: "3", label: "Associated clinic" },
  { value: "4", label: "Private Facility" },
  { value: "5", label: "Govt. Facility" },
];
const referralService = [
  { value: "1", label: "Menstrual Health" },
  { value: "2", label: "Anaemia" },
  { value: "3", label: "Family Planning" },
  { value: "4", label: "Sexual orientation counseling" },
  { value: "5", label: "Relationship counseling" },
  { value: "6", label: "Gender Based Violence" },
  { value: "7", label: "Urology" },
  { value: "8", label: "STI/RTI" },
  { value: "9", label: "Other" },
];
const supplierMasterHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-12 xl:w-12 2xl:w-24 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Logo",
    key: "SupplierLogo",
    width: "md:w-16 lg:w-16 xl:w-20 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Supplier Id",
    key: "SupplierId",
    width: "md:w-28 lg:w-24 xl:w-36 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Supplier Name",
    key: "SupplierName",
    width: "md:w-32 lg:w-32 xl:w-44 2xl:m-auto 2xl:w-60 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "City",
    key: "LocationName_en",
    width: "md:w-24 lg:w-24 xl:w-36 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Mobile",
    key: "SupplierMobileNumber",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Email",
    key: "SupplierEmailId",
    width: "md:w-32 lg:w-28 xl:w-60 2xl:m-auto 2xl:w-48 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5 ",
  },
];

const OutSchoolHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5  ",
    width1: "text-red-500",
  },

  {
    title: "Youth Group Name",
    key: "schoolName",
    width:
      "md:w-52 xl:w-96 2xl:w-72 whitespace-normal break-words  px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Youth Name",
    key: "studentName",
    width: "md:w-60 whitespace-normal break-words  px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Session Number",
    key: "eventNumber",
    width: "md:w-44 2xl:w-22 whitespace-normal break-words  px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Module",
    key: "module",
    width: "md:w-36 2xl:w-64 whitespace-normal break-words  px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5",
  },
];
const SingleSessionOnlineHeader = [
  {
    title: "S.No.",
    key: "txn_singlesessiononlineId",
    width: "md:w-12 2xl:w-12 px-1 py-1.5  ",
  },
  {
    title: "Date",
    key: "SEODate",
    width: "md:w-28 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Start Time",
    key: "SEOStartTime",
    width: "md:w-28  2xl:w-28 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "End Time",
    key: "SEOEndTime",
    width: "md:w-28 2xl:w-28 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Venue",
    key: "SEOVenue",
    width: "md:w-28 2xl:w-28 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5 ",
  },
];

const SingleSessionHeader = [
  {
    title: "S.No.",
    key: "txn_singlesessionId",
    width: "md:w-10 lg:w-10 xl:w-10 2xl:w-10 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "FormatSEODate",
    width: "md:w-24 lg:w-24 xl:w-24  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Time",
    key: "SEOStartEndTimes",
    width: "md:w-40 lg:w-40 xl:w-40  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Mode",
    key: "RadioSessionTypes",
    width:
      "md:w-30 whitespace-normal break-words xl:w-30 2xl:w-30 lg:w-30 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Resource Person",
    key: "ResourcesName1",
    width: "md:w-56 2xl:w-96 lg:w-44 xl:w-80 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Total No.Of Participants",
    key: "SEONoOfParticipants",
    width:
      "md:w-24 lg:w-24 2xl:w-24 xl:w-24 whitespace-pre-line px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5 ",
  },
];
const AwarenessGender = [
  { value: "1", label: "Male" },
  { value: "2", label: "Female" },
  { value: "3", label: "Other" },
];
const AwarenessAge = [
  { value: "1", label: "10-14" },
  { value: "2", label: "15-19" },
  { value: "3", label: "20-24" },
];

const ReferralServiceCSE = [
  { value: "1", label: "Menstrual Health" },
  { value: "2", label: "Anaemia" },
  { value: "3", label: "Family Planning" },
  { value: "4", label: "Sexual orientation counseling " },
  { value: "5", label: "Relationship counseling" },
  { value: "6", label: "Gender Based Violence" },
  { value: "7", label: "Urology" },
  { value: "8", label: "STI/RTI" },
  { value: "9", label: "Other" },
];
const contraceptiveHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Contraceptive Categories",
    key: "CommodityCategory_en",
    width: "md:w-44 lg:w-48 2xl:w-48 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Contraceptive Name",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Unit Of Measure",
    key: "CommodityUOM",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Item Category",
    key: "ItemCategory",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Description",
    key: "Description_en",
    width: "md:w-20 lg:w-60  xl:w-60 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5 2xl:m-auto",
  },
];
const socialMarketingHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5  ",
  },
  {
    title: "Social Marketing Categories",
    key: "CommodityCategory_en",
    width: "md:w-48 lg:w-52 xl:w-52 2xl:w-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Social Marketing Name",
    key: "CommodityName_en",
    width: "md:w-40 lg:w-40 xl:w-52 2xl:w-48 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Unit Of Measure",
    key: "CommodityUOM",
    width: "md:w-36 lg:w-36 xl:w-40 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  //  {
  //   title: "Item Category",
  //   key: "ItemCategory",
  //   width: "md:w-36 lg:w-36 xl:w-36 2xl:mw-52 px-1 py-1.5 ",
  //   width1: "text-red-500",
  // },
  {
    title: "Description",
    key: "Description_en",
    width: "md:w-20 lg:w-60  xl:w-60 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5 2xl:m-auto",
  },
];

const medicinesDrugsHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5  ",
  },
  {
    title: "Medicines Category",
    key: "CommodityCategory_en",
    width: "md:w-36 lg:w-36 xl:w-48 2xl:w-48 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Medicines / Drugs Name",
    key: "CommodityName_en",
    width: "md:w-44 lg:w-44 xl:w-48 2xl:w-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Route",
    key: "ModeName",
    width: "md:w-24 lg:w-20 xl:w-32 2xl:w-32 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Unit Of Measure",
    key: "CommodityUOM",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  //  {
  //   title: "Item Category",
  //   key: "ItemCategory",
  //   width: "md:w-36 lg:w-36 xl:w-36 2xl:mw-52 px-1 py-1.5 ",
  //   width1: "text-red-500",
  // },
  {
    title: "Description",
    key: "Description_en",
    width: "md:w-20 lg:w-60  xl:w-60 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5 2xl:m-auto",
  },
];
const consumablesHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5  ",
  },
  {
    title: "Consumables Categories",
    key: "CommodityCategory_en",
    width: "md:w-48 lg:w-48 xl:w-60 2xl:w-48 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Consumables Name",
    key: "CommodityName_en",
    width: "md:w-40 lg:w-40 xl:w-60 2xl:w-48 px-1 py-1.5",
    width1: "text-red-500",
  },

  {
    title: "Unit Of Measure",
    key: "CommodityUOM",
    width: "md:w-36 lg:w-36 xl:w-40 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Description",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5 2xl:m-auto",
  },
];
const inventoryIssueDetailsHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "md:w-12 2xl:flex-1 text-gray-900 px-1 py-1.5  ",
  },
  {
    title: "Category",
    key: "CommodityCategory_en",
    width: "md:w-28 px-1 py-1.5 ",
  },

  {
    title: "Name",
    key: "CommodityName_en",
    width: "md:w-56  whitespace-normal break-words  px-1 py-1.5",
    width1:
      "md:w-44  whitespace-normal break-words text-red-600 2xl:flex-1 px-1 py-1.5  ",
  },
  {
    title: "Brand",
    key: "Brand_en",
    width: "md:w-28 xl:w-56 whitespace-normal break-words  px-1 py-1.5 ",
    width1:
      "md:w-44  whitespace-normal break-words text-red-600 2xl:flex-1 px-1 py-1.5  ",
  },
  {
    title: "Batch",
    key: "IssuesBatch",
    width: "md:w-32  whitespace-normal break-words  px-1 py-1.5",
    width1:
      "md:w-44  whitespace-normal break-words text-red-600 2xl:flex-1 px-1 py-1.5  ",
  },
  {
    title: "Exp. Date",
    key: "FormattedExpiryDate",
    width: "md:w-28  whitespace-normal break-words  px-1 py-1.5 ",
    width1:
      "md:w-32  whitespace-normal break-words text-red-600 2xl:flex-1 px-1 py-1.5  ",
  },
  {
    title: "Issued Qty.",
    key: "IssuesQuantity",
    width: "md:w-28  whitespace-normal break-words  px-1 py-1.5 ",
    width1:
      "md:w-32  whitespace-normal break-words text-red-600 2xl:flex-1 px-1 py-1.5  ",
  },
  {
    title: "UOM",
    key: "IssuesUOM",
    width: "md:w-20  px-1 py-1.5 ",
    width1: "md:w-32  whitespace-normal break-words text-red-600 px-1 py-1.5  ",
  },
];
const inventoryIssueHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-14 2xl:w-12 px-1 py-1.5 ",
    width1: "text-red-600",
  },
  {
    title: "Indent No.",
    key: "IndentNo",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-600",
  },
  {
    title: "Indent Date",
    key: "IndentDate",
    width: "md:w-24 lg:w-24 xl:w-32 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-600",
  },
  {
    title: "Issued No.",
    key: "IssueNo",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-600",
  },
  {
    title: "Issued Date",
    key: "IssueDate",
    width: "md:w-24 lg:w-24 xl:w-32 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-600",
  },
  {
    title: "Issued To",
    key: "ReceivedFrom_en",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Receiver",
    key: "LocationName_en",
    width: "md:w-20 lg:w-16 xl:w-40 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "AreaName_en",
    width: "md:w-20 lg:w-16 xl:w-40 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-600",
  },
  {
    title: "Action",
    key: "IssueAction",
    width: "w-24 px-1 py-1.5",
  },
];
const inventoryDirectIssueHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-14 2xl:w-12 px-1 py-1.5 ",
    width1: "text-red-600",
  },
  {
    title: "Issued No.",
    key: "IssueNo",
    width: "md:w-20 lg:w-20 xl:w-32 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-600",
  },
  {
    title: "Issued Date",
    key: "IssueDate",
    width: "md:w-24 lg:w-24 xl:w-36 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "AreaName_en",
    width: "md:w-20 lg:w-16 xl:w-60 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-600",
  },
  {
    title: "Issued Through",
    key: "IssuedThrough",
    width: "md:w-28 lg:w-28 xl:w-52 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Remarks",
    key: "IssueRemarks_en",
    width: "md:w-20 lg:w-16 xl:w-36 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-600",
  },
  {
    title: "Action",
    key: "IssueAction",
    width: "w-24 px-1 py-1.5",
  },
];
const pendingIndentHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5",
  },

  {
    title: "Indent No.",
    key: "IndentNo",
    width: "md:w-28 lg:w-28 xl:w-40 2xl:flex-1 px-1 py-1.5 ",
  },
  {
    title: "Indent Date",
    key: "IndentDate",
    width: "md:w-28 lg:w-28 xl:w-40 2xl:flex-1 px-1 py-1.5 ",
  },
  {
    title: "Requested By",
    key: "IndentFrom1_en",
    width: "md:w-28 lg:w-28 xl:w-44 2xl:flex-1 px-1 py-1.5",
  },
  {
    title: "Name",
    key: "IndentFrom2_en",
    width: "md:w-28 lg:w-28 xl:w-44 2xl:flex-1 px-1 py-1.5",
  },
  {
    title: "Area",
    key: "AreaName_en",
    width: "md:w-28 lg:w-28 xl:w-44 2xl:flex-1 px-1 py-1.5 mr-auto ",
  },
  {
    title: "Action",
    key: "PendingIndentAction",
    width: "md:w-28 px-1 py-1.5 text-center",
  },
];
const indentDetailsHeader = [
  {
    title: "S.No.",
    key: "SNo",
    width: "md:w-12 px-1 py-1.5",
  },
  {
    title: "Commodity",
    key: "CommodityCategory_en",
    width: "md:w-52 px-1 py-1.5 ",
  },
  {
    title: "Name",
    key: "CommodityName_en",
    width: "md:w-48 2xl:w-44 px-1 py-1.5",
  },
  {
    title: "Indent Quantity",
    key: "IndentQuantity",
    width: "md:w-32 2xl:w-32 px-1 py-1.5 mr-auto ",
  },
  {
    title: "Issued Before",
    key: "IssuedBefore",
    width: "md:w-28 2xl:w-32 px-1 py-1.5 mr-auto ",
  },
  {
    title: "Pending Quantity",
    key: "IndentPendingQuantity",
    width: "md:w-32 2xl:w-32 px-1 py-1.5 mr-auto ",
  },
];
const issueDetailsHeader = [
  {
    title: "S.No.",
    key: "SNo",
    width: "md:w-12 px-1 py-1.5",
  },
  {
    title: "Category",
    key: "CommodityCategory_en",
    width: "md:w-28 lg:48 2xl:w-44 px-1 py-1.5",
  },
  {
    title: "Name",
    key: "CommodityName_en",
    width: "md:w-32 lg:48 2xl:w-44 px-1 py-1.5",
  },
  {
    title: "Brand",
    key: "issueBrand",
    width: "md:w-32 lg:48 2xl:w-44 px-1 py-1.5",
  },
  {
    title: "Batch",
    key: "BatchNo",
    width: "md:w-24 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Exp.Dt",
    key: "ExpiryDate",
    width: "md:w-36 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Available Stock",
    key: "Available",
    width: "md:w-28 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Issued Now",
    key: "IssueQuantity",
    width: "md:w-28 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Balance Stock",
    key: "Balance",
    width: "md:w-28 px-1 py-1.5 2xl:w-32 text-center",
  },
  {
    title: "Action",
    key: "issueAction",
    width: "w-16 px-1 py-1.5",
  },
];
const issueDetailsEditHeader = [
  {
    title: "S.No.",
    key: "SNo",
    width: "md:w-12 px-1 py-1.5",
  },
  {
    title: "Category",
    key: "CommodityCategory_en",
    width: "md:w-28 lg:48 2xl:w-44 px-1 py-1.5",
  },
  {
    title: "Name",
    key: "CommodityName_en",
    width: "md:w-32 lg:48 2xl:w-44 px-1 py-1.5",
  },
  {
    title: "Brand",
    key: "issueBrand",
    width: "md:w-32 lg:48 2xl:w-44 px-1 py-1.5",
  },
  {
    title: "Batch",
    key: "BatchNo",
    width: "md:w-24 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Exp.Dt",
    key: "ExpiryDate",
    width: "md:w-36 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Available Stock",
    key: "Available",
    width: "md:w-28 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Issued Now",
    key: "IssueQuantity",
    width: "md:w-28 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Balance Stock",
    key: "Balance",
    width: "md:w-28 px-1 py-1.5 2xl:w-32 text-center",
  },
];
const issueIndentDetailsHeader = [
  {
    title: "S.No.",
    key: "SNo",
    width: "md:w-12 px-1 py-1.5",
  },
  {
    title: "Category",
    key: "CommodityCategory_en",
    width: "md:w-24 lg:48 text-center 2xl:w-44 px-1 py-1.5",
  },
  {
    title: "Name",
    key: "CommodityName_en",
    width: "md:w-28 lg:48 text-center 2xl:w-44 px-1 py-1.5",
  },
  {
    title: "Brand",
    key: "issueBrand",
    width: "md:w-32 lg:48 2xl:w-44 px-1 py-1.5",
  },
  {
    title: "Batch",
    key: "BatchNo",
    width: "md:w-24 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Exp.Dt",
    key: "ExpiryDate",
    width: "md:w-36 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Available Stock",
    key: "Available",
    width: "md:w-28 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Issued Before",
    key: "IssuedBefore",
    width: "md:w-28 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Issued Now",
    key: "IssueQuantity",
    width: "md:w-28 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Balance Stock",
    key: "Balance",
    width: "md:w-28 px-1 py-1.5 2xl:w-32 text-center",
  },
  {
    title: "Action",
    key: "issueAction",
    width: "w-16 px-1 py-1.5",
  },
];
const issueIndentDetailsEditHeader = [
  {
    title: "S.No.",
    key: "SNo",
    width: "md:w-12 px-1 py-1.5",
  },
  {
    title: "Category",
    key: "CommodityCategory_en",
    width: "md:w-24 lg:48 text-center 2xl:w-44 px-1 py-1.5",
  },
  {
    title: "Name",
    key: "CommodityName_en",
    width: "md:w-28 lg:48 text-center 2xl:w-44 px-1 py-1.5",
  },
  {
    title: "Brand",
    key: "issueBrand",
    width: "md:w-32 lg:48 2xl:w-44 px-1 py-1.5",
  },
  {
    title: "Batch",
    key: "BatchNo",
    width: "md:w-24 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Exp.Dt",
    key: "ExpiryDate",
    width: "md:w-36 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Available Stock",
    key: "Available",
    width: "md:w-28 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Issued Before",
    key: "IssuedBefore",
    width: "md:w-28 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Issued Now",
    key: "IssueQuantity",
    width: "md:w-28 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Balance Stock",
    key: "Balance",
    width: "md:w-28 px-1 py-1.5 2xl:w-32 text-center",
  },
];
const issueDetailsHeaderPopup = [
  {
    title: "S.No.",
    key: "SNo",
    width: "md:w-12 px-1 py-1.5",
  },
  {
    title: "CommodityType",
    key: "CommodityType_en",
    width: "md:w-28 lg:48 2xl:w-48 px-1 py-1.5",
  },
  {
    title: "Category",
    key: "CommodityCategory",
    width: "md:w-28 lg:48 2xl:w-44 px-1 py-1.5",
  },
  {
    title: "Name",
    key: "CommodityName_en",
    width: "md:w-28 lg:48 2xl:w-44 px-1 py-1.5",
  },
  {
    title: "Brand",
    key: "Brand_en",
    width: "md:w-28 lg:48 2xl:w-44 px-1 py-1.5",
  },
  {
    title: "Batch",
    key: "IssuesBatch",
    width: "md:w-16 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Exp. Date",
    key: "ExpiryDate",
    width: "md:w-24 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Available",
    key: "ReceiptBalance",
    width: "md:w-20 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Issue Qty.",
    key: "IssueQuantity",
    width: "md:w-16 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Balance",
    key: "Balance",
    width: "md:w-20 px-1 py-1.5 2xl:w-32 text-center",
  },
];
const issueDetailsPopUpHeader = [
  {
    title: "S.No.",
    key: "SNo",
    width: "md:w-12 px-1 py-1.5",
  },
  {
    title: "CommodityType",
    key: "CommodityType_en",
    width: "md:w-28 lg:48 2xl:w-48 px-1 py-1.5",
  },
  {
    title: "Category",
    key: "CommodityCategory_en",
    width: "md:w-24 lg:48 2xl:w-44 px-1 py-1.5",
  },
  {
    title: "Name",
    key: "CommodityName_en",
    width: "md:w-24 lg:48 2xl:w-44 px-1 py-1.5",
  },
  {
    title: "Brand",
    key: "Brand_en",
    width: "md:w-24 lg:48 2xl:w-44 px-1 py-1.5",
  },
  {
    title: "Batch",
    key: "IssuesBatch",
    width: "md:w-16 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Exp. Date",
    key: "ReceiptDateOfExpiry",
    width: "md:w-24 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Available",
    key: "Available1",
    width: "md:w-20 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Issue Qty.",
    key: "IssuesQuantity1",
    width: "md:w-20 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Balance",
    key: "Balance1",
    width: "md:w-20 px-1 py-1.5 2xl:w-32 text-center",
  },
];

const PartnerOrganizationHeader = [
  {
    title: "S.No.",
    key: "Sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Country",
    key: "CountryName_en",
    width: "md:w-40 lg:w-40 xl:w-40 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "State",
    key: "StateName_en",
    width: "md:w-40 lg:w-40 xl:w-40 2xl:m-auto px-1 py-1.5",
  },
  {
    title: "Branch/Project",
    key: "LocationName_en",
    width: "md:w-40 lg:w-40 xl:w-40 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Partner Organization",
    key: "PartnerOrganizationName",
    width: "md:w-40 lg:w-40 xl:w-72 2xl:m-auto px-1 py-1.5 mr-auto",
  },

  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5 ",
  },
];
const CBPHeader = [
  {
    title: "S.No.",
    key: "Sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Country",
    key: "CountryName_en",
    width: "md:w-36 lg:w-36 xl:w-40 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "State",
    key: "StateName_en",
    width: "md:w-40 lg:w-36 xl:w-48 2xl:m-auto px-1 py-1.5",
  },
  {
    title: "Branch/Project",
    key: "LocationName_en",
    width: "md:w-40 lg:w-36 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "CBP",
    key: "CBPName",
    width: "md:w-40 lg:w-40 xl:w-40 2xl:m-auto px-1 py-1.5 mr-auto",
  },

  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5 ",
  },
];
const brandHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Commodities",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-40 xl:w-40 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Commodity Category",
    key: "CommodityCategory_en",
    width: "md:w-40 lg:w-40 xl:w-72 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Name",
    key: "CommodityName_en",
    width: "md:w-44 lg:w-44 xl:w-44 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Brand",
    key: "Brand_en",
    width: "md:w-44 lg:w-44 xl:w-44 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5 ",
  },
];

const consumptionHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-12  2xl:w-12 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Consumption No.",
    key: "ConsumptionNo",
    width: "md:w-32 lg:w-32 xl:w-36  2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "ConsumptionDateFormat",
    width: "md:w-24 lg:w-24 xl:w-28   2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Commodities",
    key: "CommodityType_en",
    width: "md:w-24 lg:w-28 xl:w-32 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Branch",
    key: "LocationName_en",
    width: "md:w-24 lg:w-20 xl:w-40 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "S.D.P.",
    key: "SDP_en",
    width: "md:w-20 lg:w-20 xl:w-36 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Reason",
    key: "Reason_en",
    width: "md:w-20 lg:w-20 xl:w-32 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "receiptAction",
    width: " px-1 py-1.5 md:w-32  ",
  },
];

const ReportInschoolSession = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:w-14 lg:w-12 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "School ID No.",
    key: "SchoolId",
    width: "md:w-24 lg:w-20 xl:w-28 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Student Roll/ ID No.",
    key: "SessionNumber",
    width: "md:w-32 lg:w-24 xl:w-60 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Class",
    key: "Class",
    width: "md:w-32 whitespace-normal break-words 2xl:w-72 lg:w-44 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Division",
    key: "Division",
    width: "md:w-32 2xl:w-44 lg:w-32  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Age (In Years)",
    key: "Age",
    width: "md:w-32 lg:w-36 2xl:w-52  px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Gender (M/ F/ O)",
    key: "Gender",
    width: "md:w-20 whitespace-normal break-words lg:w-32 2xl:w-40 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Division",
    key: "Division",
    width: "md:w-32 2xl:w-44 lg:w-32  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "1: Sexual health and well being, human rights",
    key: "Age",
    width: "md:w-32 lg:w-36 2xl:w-52  px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "2: Gender, gender based violence",
    key: "Gender",
    width: "md:w-20 whitespace-normal break-words lg:w-32 2xl:w-40 px-1 py-1.5",
    width1: "text-red-500",
  },
];

const ReferralTrackingHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Date",
    key: "FormattedDate",
    width: "md:w-20 lg:w-20 xl:w-202xl:w-20 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Beneficiary name",
    key: "ParticipantName_en",
    width:
      "md:w-32 lg:w-32 xl:w-32 2xl:w-60 whitespace-pre-line whitespace-normal break-words px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Mobile no.",
    key: "MobileNo",
    width: "md:w-28 lg:w-28 xl:w-28 2xl:w-28 whitespace-pre-line px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Referral service",
    key: "ReferredBy_en",
    width: "md:w-32 lg:w-32 xl:w-32 2xl:w-52 whitespace-pre-line px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Referred to",
    key: "ReferredTo_en",
    width: "md:w-32 lg:w-32 xl:w-32 2xl:w-52 whitespace-pre-line px-1 py-1.5  ",
  },
  {
    title: "Service received",
    key: "ServiceReceived",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:w-24 whitespace-pre-line px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Follow-Up By",
    key: "FormattedFollowUpBy",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-20 whitespace-pre-line px-1 py-1.5  ",
  },
  {
    title: "Date followed up",
    key: "DateFollowedUp",
    width:
      "md:w-40 lg:w-36 xl:w-40 2xl:w-40 whitespace-pre-line px-1 py-1.5 mr-auto ",
  },
  {
    title: "Action",
    key: "ReferralTrackingSave",
    width: "w-24 px-1 py-1.5 2xl:text-center",
  },
];


const excelExportReferralTrackingHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  }, {
    title: "TxnReferralTrackingId",
    key: "FormattedDate",
    width: "md:w-20 lg:w-20 xl:w-202xl:w-20 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Date",
    key: "FormattedDate",
    width: "md:w-20 lg:w-20 xl:w-202xl:w-20 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Beneficiary name",
    key: "ParticipantName_en",
    width:
      "md:w-32 lg:w-32 xl:w-32 2xl:w-60 whitespace-pre-line whitespace-normal break-words px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Mobile no.",
    key: "MobileNo",
    width: "md:w-28 lg:w-28 xl:w-28 2xl:w-28 whitespace-pre-line px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Referral service",
    key: "ReferredBy_en",
    width: "md:w-32 lg:w-32 xl:w-32 2xl:w-52 whitespace-pre-line px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Referred to",
    key: "ReferredTo_en",
    width: "md:w-32 lg:w-32 xl:w-32 2xl:w-52 whitespace-pre-line px-1 py-1.5  ",
  },
  {
    title: "Service received",
    key: "ServiceReceived",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:w-24 whitespace-pre-line px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Follow-Up By",
    key: "FormattedFollowUpBy",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-20 whitespace-pre-line px-1 py-1.5  ",
  },
  {
    title: "Date followed up",
    key: "DateFollowedUp",
    width:
      "md:w-40 lg:w-36 xl:w-40 2xl:w-40 whitespace-pre-line px-1 py-1.5 mr-auto ",
  },
  {
    title: "Created By",
    key: "DateFollowedUp",
    width:
      "md:w-40 lg:w-36 xl:w-40 2xl:w-40 whitespace-pre-line px-1 py-1.5 mr-auto ",
  },
];

const clientChildrenDetailsHeaders = [
  {
    title: "Order of children",
    key: "childrenOrder",
    width: "w-32 whitespace-normal break-normal px-1 py-1.5",
  },
  {
    title: "Years",
    key: "clientYears",
    width: "w-20  break-normal  px-1 py-1.5",
  },
  {
    title: "Months",
    key: "clientMonths",
    width: "w-16  break-normal  px-1 py-1.5",
  },
  {
    title: "Days",
    key: "clientDays",
    width: "w-16  break-normal  px-1 py-1.5",
  },
  {
    title: "Gender (M /F /O)",
    key: "clientGender",
    width: "w-32  break-normal  px-1 py-1.5",
  },
];

const contraceptiveRSFHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-12 xl:w-12 2xl:w-12  px-1 py-1.5",
  },
  {
    title: "Date",
    key: "FormattedDate",
    width: "md:w-20 lg:w-20 xl:w-18 2xl:w-28    px-1 py-1.5",
  },
  {
    title: "Service Dt.",
    key: "FormattedServiceDate",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-28    px-1 py-1.5",
  },

  {
    title: "Client Name",
    key: "ClientFirstName_en",
    width: "md:w-28 lg:w-28 xl:w-28 2xl:w-48 whitespace-pre-line px-1 py-1.5",
  },
  {
    title: "Client ID",
    key: "ClientID",
    width: "md:w-28 lg:w-28 xl:w-40 2xl:w-48  px-1 py-1.5",
  },
  {
    title: "Mobile No.",
    key: "ClientPhoneNo",
    width: "md:w-32 lg:w-32 xl:w-32 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "FP Method",
    key: "Services_en",
    width: "md:w-32 lg:w-20 xl:w-28 2xl:w-32 px-1 py-1.5",
  },

  {
    title: "Remarks",
    key: "ContraceptiveRemarks",
    width: "md:w-32 lg:w-32 xl:w-32 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Reason",
    key: "Reason",
    width: "md:w-32 lg:w-32 xl:w-32 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Next Follow-up",
    key: "ContraceptiveNextFollowUpDate",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Save",
    key: "NotificationSave",
    width: "md:w-16 lg:w-16 xl:w-14 2xl:w-32 px-1 py-1.5",
  },
];

const ReferralFollowUpNotificationsHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12  px-1 py-1.5",
  },
  {
    title: "Date",
    key: "FormattedDate",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:w-28    px-1 py-1.5",
  },
  {
    title: "Client Name",
    key: "ClientFirstName_en",
    width: "md:w-24 lg:w-24 xl:w-52 2xl:w-28    px-1 py-1.5",
  },

  {
    title: "Client ID",
    key: "ClientID",
    width: "md:w-28 lg:w-28 xl:w-52 2xl:w-48 whitespace-pre-line px-1 py-1.5",
  },
  {
    title: "Mobile No.",
    key: "ClientPhoneNo",
    width: "md:w-48 lg:w-48 xl:w-40 2xl:w-48  px-1 py-1.5",
  },
  {
    title: "Referral Service",
    key: "ReferredTo_en",
    width: "md:w-32 lg:w-32 xl:w-44 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Remarks",
    key: "ReferralFollowUpRemarks",
    width: "md:w-32 lg:w-20 xl:w-52 2xl:w-32 px-1 py-1.5",
  },
  {
    title: "Save",
    key: "NotificationSave",
    width: "  px-1 py-1.5",
  },
];

const openingStockHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-24 px-1 py-1.5  ",
  },
  {
    title: "Commodities",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-36 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Category",
    key: "CommodityCategory_en",
    width: "md:w-44 lg:w-44 xl:w-52 2xl:m-auto px-1 py-1.5 mr-auto",
  },
  {
    title: "Name",
    key: "CommodityName_en",
    width: "md:w-44 lg:w-44 xl:w-52 2xl:m-auto px-1 py-1.5 mr-auto",
  },
  {
    title: "Brand",
    key: "Brand_en",
    width: "md:w-28 lg:w-28 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },

  {
    title: "U.O.M",
    key: "CommodityUOM",
    width: "md:w-18 lg:w-18 xl:w-24 2xl:m-auto px-1 py-1.5 mr-auto",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5 2xl:m-auto",
  },
];

const districtMasterHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-14 2xl:w-12 px-1 py-1.5  m-auto",
  },
  {
    title: "Country",
    key: "CountryName_en",
    width: "md:w-52 2xl:flex-1 px-1 py-1.5 ",
  },
  {
    title: "State",
    key: "StateName_en",
    width: "md:w-60 2xl:flex-1 px-1 py-1.5 m-auto",
  },
  {
    title: "District",
    key: "District_en",
    width: "md:w-60 2xl:flex-1 px-1 py-1.5 m-auto",
  },

  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
];

const blockMasterHeader = [
  {
    title: "S.No.",
    key: "Sno",
    width: "md:w-14 2xl:w-12 px-1 py-1.5  m-auto",
  },
  {
    title: "Country",
    key: "CountryName_en",
    width: "md:w-60 2xl:flex-1 px-1 py-1.5 m-auto",
  },
  {
    title: "State",
    key: "StateName_en",
    width: "md:w-60 2xl:flex-1 px-1 py-1.5 m-auto",
  },
  {
    title: "District",
    key: "District_en",
    width: "md:w-60 2xl:flex-1 px-1 py-1.5 m-auto",
  },
  {
    title: "Block",
    key: "Block_en",
    width: "md:w-60 2xl:flex-1 px-1 py-1.5 m-auto",
  },

  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
];

const cityvillageMasterHeader = [
  {
    title: "S.No.",
    key: "Sno",
    width: "md:w-14 2xl:w-12 px-1 py-1.5  m-auto",
  },
  {
    title: "Country",
    key: "CountryName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
  },
  {
    title: "State",
    key: "StateName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
  },
  {
    title: "District",
    key: "District_en",
    width: "flex-1 px-1 py-1.5 m-auto",
  },
  {
    title: "Block",
    key: "Block_en",
    width: "flex-1 px-1 py-1.5 m-auto",
  },
  {
    title: "City / village",
    key: "City_en",
    width: "flex-1 px-1 py-1.5 m-auto",
  },

  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
];

const doctorAppoinmentsHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-10 2xl:w-10 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Client Id",
    key: "ClientId",
    width: "md:w-60 lg:w-60 xl:w-60 whitespace-pre-line 2xl:w-60 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Client Name",
    key: "ClientName_en",
    width: "md:w-40 lg:w-40 xl:w-40 whitespace-pre-line  2xl:w-72 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Gender / Age",
    key: "ClientGenderAge_en",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Phone",
    key: "ClientPhoneNo",
    width: "md:w-28 lg:w-28 xl:w-28 2xl:w-28 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Appointment",
    key: "LocationName_en",
    width: "md:w-60 lg:w-60 xl:w-56 2xl:w-60 whitespace-pre-line px-1 py-1.5",
  },
  {
    title: "Services",
    key: "DoctorConsultationAction",
    width: "px-1 py-1.5 md:w-16 2xl:mr-auto mr-auto",
  },
  {
    title: "Action",
    key: "appointmentsAction",
    width: "px-1 py-1.5 md:w-32",
  },
];
const CSEInSchoolReportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "School Name",
    key: "SchoolName",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Name of the Student",
    key: "StudentName",
    width: "md:w-24 lg:w-24 xl:w-40 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Student Roll No.",
    key: "RollId",
    width: "md:w-24 lg:w-24 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Class",
    key: "MstCSEClass",
    width: "md:w-24 lg:w-28 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Division",
    key: "Division",
    width: "md:w-24 lg:w-28 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Age group",
    key: "Age",
    width: "md:w-24 lg:w-28 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Gender (M/ F/ O)",
    key: "Gender",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Module 1: Gender",
    key: "1)Gender",
    width: "md:w-24 lg:w-28 xl:w-48 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Module 2: Sexual and Reproductive Health",
    key: "2)Sexual and Reproductive Health",
    width: "md:w-24 lg:w-28 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Module 3: Sexual Rights and Sexual Citizenship",
    key: "3)Sexual Rights and Sexual Citizenship",
    width: "md:w-24 lg:w-28 xl:w-48 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Module 4: Pleasure",
    key: "4)Pleasure",
    width: "md:w-24 lg:w-28 xl:w-48 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Module 5: Violence",
    key: "5)Violence",
    width: "md:w-24 lg:w-28 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Module 6: Diversity",
    key: "6)Diversity",
    width: "md:w-24 lg:w-28 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Module 7: Relationships",
    key: "7)Relationships",
    width: "md:w-24 lg:w-28 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "No. of modules completed",
    key: "No. of modules completed",
    width: "md:w-24 lg:w-28 xl:w-48 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "No. of modules",
    key: "Modules",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "No. of sessions",
    key: "Sessions",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Date of first session (S1)",
    key: "FirstDate",
    width: "md:w-24 lg:w-28 xl:w-48 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Duration (days)  to complete",
    key: "DateDifference",
    width: "md:w-24 lg:w-28 xl:w-48 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Type (1)",
    key: "ResourcepersonType1",
    width: "md:w-24 lg:w-28 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Type (2)",
    key: "ResourcepersonType2",
    width: "md:w-24 lg:w-28 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Type (3)",
    key: "ResourcepersonType3",
    width: "md:w-24 lg:w-28 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Type (4)",
    key: "ResourcepersonType4",
    width: "md:w-24 lg:w-28 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Name (1)",
    key: "ResourcePersonName1",
    width: "md:w-24 lg:w-28 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Name (2)",
    key: "ResourcePersonName2",
    width: "md:w-24 lg:w-28 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Name (3)",
    key: "ResourcePersonName3",
    width: "md:w-24 lg:w-28 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Name (4)",
    key: "ResourcePersonName4",
    width: "md:w-24 lg:w-28 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Name (5)",
    key: "ResourcePersonName5",
    width: "md:w-24 lg:w-28 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Name (6)",
    key: "ResourcePersonName6",
    width: "md:w-24 lg:w-28 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Name (7)",
    key: "ResourcePersonName7",
    width: "md:w-24 lg:w-28 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Name (8)",
    key: "ResourcePersonName8",
    width: "md:w-24 lg:w-28 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
];

const CSEOutSchoolReportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Youth Group Name",
    key: "YouthGroupName",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Name of the Youth Member",
    key: "YouthName",
    width: "md:w-24 lg:w-24 xl:w-40 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Youth ID",
    key: "YouthId",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Age group",
    key: "Age",
    width: "md:w-24 lg:w-28 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Gender (M/ F/ O)",
    key: "Gender",
    width: "md:w-24 lg:w-28 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Module 1: Gender",
    key: "Module1",
    width: "md:w-24 lg:w-28 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Module 2: Sexual and Reproductive Health",
    key: "Module2",
    width: "md:w-24 lg:w-28 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Module 3: Sexual Rights and Sexual Citizenship",
    key: "Module3",
    width: "md:w-24 lg:w-28 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Module 4: Pleasure",
    key: "Module4",
    width: "md:w-24 lg:w-24 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Module 5: Violence",
    key: "Module5",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Module 6: Diversity",
    key: "Module6",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Module 7: Relationships",
    key: "Module7",
    width: "md:w-24 lg:w-28 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "No. of modules completed",
    key: "Noofmodulescompleted",
    width: "md:w-24 lg:w-28 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "No. of modules",
    key: "Modules",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "No. of sessions",
    key: "Sessions",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Date of first session (S1)",
    key: "FirstDate",
    width: "md:w-24 lg:w-28 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Duration (days)  to complete",
    key: "DateDifference",
    width: "md:w-24 lg:w-28 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Type (1)",
    key: "ResourcepersonType1",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Type (2)",
    key: "ResourcepersonType2",
    width: "md:w-24 lg:w-28 xl:w-48 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Type (3)",
    key: "ResourcepersonType3",
    width: "md:w-24 lg:w-28 xl:w-48 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Type (4)",
    key: "ResourcepersonType4",
    width: "md:w-24 lg:w-28 xl:w-48 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Name (1)",
    key: "ResourcePersonName1",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Name (2)",
    key: "ResourcePersonName2",
    width: "md:w-24 lg:w-28 xl:w-48 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Name (3)",
    key: "ResourcePersonName3",
    width: "md:w-24 lg:w-28 xl:w-48 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Name (4)",
    key: "ResourcePersonName4",
    width: "md:w-24 lg:w-28 xl:w-48 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Name (5)",
    key: "ResourcePersonName5",
    width: "md:w-24 lg:w-28 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Name (6)",
    key: "ResourcePersonName6",
    width: "md:w-24 lg:w-28 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Name (7)",
    key: "ResourcePersonName7",
    width: "md:w-24 lg:w-28 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Resource person Name (8)",
    key: "ResourcePersonName8",
    width: "md:w-24 lg:w-28 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
];
const CSEReferralsReportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-12 2xl:w-20 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Date",
    key: "Date",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Name",
    key: "name",
    width: "md:w-28 lg:w-28 xl:w-28 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Place / Location",
    key: "SchoolName",
    width:
      "md:w-36 lg:w-44 xl:w-52 lg:whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Name",
    key: "StudentName",
    width: "md:w-28 lg:w-32 xl:w-32 2xl:w-72 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Age group",
    key: "Age",
    width: "md:w-20 lg:w-20 xl:w-24 2xl:w-44 px-1 py-1.5",
  },
  {
    title: "Gender",
    key: "Gender",
    width: "md:w-16 lg:w-16 xl:w-24 2xl:w-44 px-1 py-1.5",
  },
  {
    title: "Referral Service",
    key: "ReferralServices",
    width: "md:w-28 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-52 px-1 py-1.5",
  },
  {
    title: "Referred to",
    key: "ReferredTo_en",
    width: "md:w-24 lg:w-24 xl:w-36 whitespace-pre-line 2xl:w-52 px-1 py-1.5",
  },
];

const DropoutsReportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "Area",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Project",
    key: "Project",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Contraception Methods",
    key: "Method",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Complication / Side-effects",
    key: "RemarksDiscontinued1",
    width: "md:w-24 lg:w-24 xl:w-56 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
    group: "Reasons for Drop Outs",
  },
  {
    title: "Failure (Method /User)/ Confirmed Pregnancy",
    key: "RemarksDiscontinued2",
    width: "md:w-24 lg:w-24 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
    group: "Reasons for Drop Outs",
  },
  {
    title: "Personal Reasons-Fears, Difficult to Use, Objection",
    key: "RemarksDiscontinued3",
    width: "md:w-24 lg:w-28 xl:w-56 2xl:w-96 whitespace-pre-line px-1 py-1.5",
    width1: "text-red-600",
    group: "Reasons for Drop Outs",
  },
  {
    title: "Supplies related Reason-Difficult to Get Another Source ",
    key: "RemarksDiscontinued4",
    width: "md:w-24 lg:w-28 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    group: "Reasons for Drop Outs",
  },
  {
    title: "Planned Pregnancy / Want child",
    key: "RemarksDiscontinued5",
    width: "md:w-24 lg:w-28 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    group: "Reasons for Drop Outs",
  },
  {
    title: "Lost to Follow-up",
    key: "RemarksDiscontinued6",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    group: "Reasons for Drop Outs",
  },
  {
    title: "Sterilisation (M+F)",
    key: "RemarksDiscontinued7",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    group: "Switched Method",
  },
  {
    title: "IUD",
    key: "RemarksDiscontinued8",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
    group: "Switched Method",
  },
  {
    title: "LNG-IUS",
    key: "RemarksDiscontinued9",
    width: "md:w-24 lg:w-28 xl:w-24 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
    group: "Switched Method",
  },
  {
    title: "Implants",
    key: "RemarksDiscontinued10",
    width: "md:w-24 lg:w-28 xl:w-24 2xl:w-96 px-1 py-1.5",
    group: "Switched Method",
  },
  {
    title: "Oral Pill",
    key: "RemarksDiscontinued11",
    width: "md:w-24 lg:w-28 xl:w-24 2xl:w-96 px-1 py-1.5",
    group: "Switched Method",
  },
  {
    title: "Condom (M+F)",
    key: "RemarksDiscontinued12",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
    group: "Switched Method",
  },
  {
    title: "Injectables",
    key: "RemarksDiscontinued13",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
    group: "Switched Method",
  },
  {
    title: "Total",
    key: "Total",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:w-96 px-1 py-1.5",
  },
];
const SingleSessionReportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Event ID.",
    key: "EventNo",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Event Date",
    key: "SEODate",
    width: "md:w-24 lg:w-24 xl:w-56 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Name of the Resource Person",
    key: "SEOResourcesPerson",
    width: "md:w-24 lg:w-24 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Mode of session (Online / Offline)",
    key: "SessionType",
    width: "md:w-24 lg:w-28 xl:w-56 2xl:w-96 whitespace-pre-line px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Venue",
    key: "SEOVenue",
    width: "md:w-24 lg:w-28 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Duration of the session",
    key: "TimeDifference",
    width: "md:w-24 lg:w-28 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "10-14",
    key: "SEOMaleChild",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "15-19",
    key: "SEOFemaleChild",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "20-24",
    key: "SEOOtherChild",
    width: "md:w-24 lg:w-24 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "No. of participants (estimated)",
    key: "SEONoOfParticipants",
    width: "md:w-24 lg:w-28 xl:w-36  whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Remarks",
    key: "SEORemarks",
    width: "md:w-24 lg:w-28 xl:w-24 2xl:w-96 px-1 py-1.5",
  },
];
const MonthlyEventsReportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Month",
    key: "MonthName",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Year",
    key: "YearId",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Teacher",
    key: "TeacherTraining",
    width: "md:w-24 lg:w-24 xl:w-56 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
    group: "Training by FPAI/Volunteers(No. of participants)",
  },
  {
    title: "NGO/CBO staff",
    key: "NGOCBOStaffTraining",
    width: "md:w-24 lg:w-24 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
    group: "Training by FPAI/Volunteers(No. of participants)",
  },
  {
    title: "Peer Educator (direct/ToT)",
    key: "PeerEducatorTrained",
    width: "md:w-24 lg:w-28 xl:w-56 2xl:w-96 whitespace-pre-line px-1 py-1.5",
    width1: "text-red-600",
    group: "Training by FPAI/Volunteers(No. of participants)",
  },
  {
    title: "Peer-to-Peer",
    key: "PeerToPeerTraining",
    group: "Training by FPAI/Volunteers(No. of participants)",
    width: "md:w-24 lg:w-28 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Parents",
    key: "Parents",
    group: "Sensitization meeting (No. of participants)",
    width: "md:w-24 lg:w-28 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Teachers",
    key: "Teachers",
    group: "Sensitization meeting (No. of participants)",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Name",
    key: "NameOfTheNGOCBO",
    group: "NGO/CBOs partner",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "No.",
    key: "NoOfNGOCBOsPartnered",
    group: "NGO/CBOs partner",
    width: "md:w-24 lg:w-24 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "Male",
    group: "Type of youth groups",
    key: "YouthGroupsFormedBoys",
    width: "md:w-24 lg:w-28 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Female",
    group: "Type of youth groups",
    key: "YouthGroupsFormedGirls",
    width: "md:w-24 lg:w-28 xl:w-24 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Other",
    group: "Type of youth groups",
    key: "YouthGroupsFormedOthers",
    width: "md:w-24 lg:w-28 xl:w-24 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Mixed",
    group: "Type of youth groups",
    key: "YouthGroupsFormedMixed",
    width: "md:w-24 lg:w-28 xl:w-24 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "No. of schools enrolled (year)",
    key: "SchoolsEnrolled",
    width: "md:w-24 lg:w-28 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "No. of schools completed",
    key: "SchoolsCompleted",
    width: "md:w-24 lg:w-28 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "No. Of Youth Groups Formed",
    key: "YouthGroupsFormedTotal",
    width: "md:w-24 lg:w-28 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Remarks",
    key: "Remarks",
    width: "md:w-24 lg:w-28 xl:w-24 2xl:w-96 px-1 py-1.5",
  },
];

const ProfileCATClientsReportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "Area",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Project",
    key: "Project",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Category-Wise Clients",
    key: "ServicesCategory_en",
    width: "w-56",
  },
  {
    title: "Gender",
    key: "Gender",
    width: "w-36",
  },
  {
    title: "0-9 Yrs",
    key: "Age0to9",
    width: "w-24",
  },
  {
    title: "10-14 Yrs",
    key: "Age10to14",
    width: "w-24",
  },
  {
    title: "15-19 Yrs",
    key: "Age15to19",
    width: "w-24",
  },
  {
    title: "20-24 Yrs",
    key: "Age20to24",
    width: "w-24",
  },
  {
    title: "25-29 Yrs",
    key: "Age25to29",
    width: "w-24",
  },
  {
    title: "30-34 Yrs",
    key: "Age30to34",
    width: "w-24",
  },
  {
    title: "35-39 Yrs",
    key: "Age35to39",
    width: "w-24",
  },
  {
    title: "40-44 Yrs",
    key: "Age40to44",
    width: "w-24",
  },
  {
    title: "45-49 Yrs",
    key: "Age45to49",
    width: "w-24",
  },
  {
    title: "50 Yrs & Above",
    key: "Age50andAbove",
    width: "w-28",
  },
];
const ProfilePACReportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "Area",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Project",
    key: "Project",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Services",
    key: "PACServices",
    width: "w-56 px-1 py-1.5",
  },
  {
    title: "Medical Abortion(MA)",
    key: "Medical Abortion(MA)",
    width: "w-60 px-1 py-1.5",
  },
  {
    title: "Surgical Abortion",
    key: "Surgical Abortion",
    width: "w-60 px-1 py-1.5",
  },
  {
    title: "Incomplete Abortion (TIA)",
    key: "Incomplete Abortion (TIA)",
    width: "w-60 px-1 py-1.5",
  },
];
const ClientProfileMEReportHeader = [
  {
    title: "Person living with disability ",
    key: "no",
    width: "w-96",
  },
  {
    title: "Visual ",
    key: "CountMstClientIdDisability1",
    width: "w-96",
  },
  {
    title: "Locomotor",
    key: "CountMstClientIdDisability2",
    width: "w-96",
  },
  {
    title: "Hearing",
    key: "CountMstClientIdDisability3",
    width: "w-96",
  },
  {
    title: "Speech",
    key: "CountMstClientIdDisability4",
    width: "w-96",
  },
  {
    title: "Intellectual",
    key: "CountMstClientIdDisability5",
    width: "w-96",
  },
  {
    title: "Multiple disability",
    key: "CountMstClientIdDisability6",
    width: "w-96",
  },
  {
    title: "Not applicable",
    key: "CountMstClientIdDisability7",
    width: "w-96",
  },
  {
    title: "Person living with disability (Total exclusive)",
    key: "CountMstClientIdMEClientsId1",
    width: "w-44 ",
  },
  {
    title: "BPL cardholder (Yes)",
    key: "TotalClientBPLCardholder",
    width: "w-96",
  },
  {
    title: "SC,ST,DT,NT",
    key: "CountMstClientIdMEClientsId2",
    width: "w-96",
  },
  {
    title: "Adolescent (10-19)",
    key: "TotalClientAge10to19",
    width: "w-96",
  },
  {
    title: "Young population (15-24)",
    key: "TotalClientAge15to24",
    width: "w-96",
  },
  {
    title: "Sex worker",
    key: "CountMstClientIdMEClientsId3",
    width: "w-96",
  },
  {
    title: "High risk Migrants",
    key: "CountMstClientIdMEClientsId4",
    width: "w-96",
  },
  {
    title: "IDU's",
    key: "CountMstClientIdMEClientsId5",
    width: "w-96",
  },
  {
    title: "PLHIV",
    key: "CountMstClientIdMEClientsId6",
    width: "w-96",
  },
  {
    title: "Transman",
    key: "CountMstClientIdMEClientsId7",
    width: "w-96",
  },
  {
    title: "Transwoman",
    key: "CountMstClientIdMEClientsId8",
    width: "w-96",
  },
  {
    title: "Transgender",
    key: "CountMstClientIdMEClientsId9",
    width: "w-96",
  },
  {
    title: "Lesbian",
    key: "CountMstClientIdMEClientsId10",
    width: "w-96",
  },
  {
    title: "Gay",
    key: "CountMstClientIdMEClientsId11",
    width: "w-96",
  },
  {
    title: "Bisexual",
    key: "CountMstClientIdMEClientsId12",
    width: "w-96",
  },
  {
    title: "Intersex",
    key: "CountMstClientIdMEClientsId13",
    width: "w-96",
  },
  {
    title: "Closed settings",
    key: "CountMstClientIdMEClientsId14",
    width: "w-96",
  },
  {
    title: "Vulnerable Woman ",
    key: "CountMstClientIdMEClientsId15",
    width: "w-96",
  },
  {
    title: "Total Marginalized and Excluded",
    key: "TotalClient",
    width: "w-44",
  },
  {
    title: "Branch",
    key: "BranchName",
    width: "w-1/6",
  },
  {
    title: "SDP",
    key: "SDP",
    width: "w-44",
  },
  {
    title: "Area",
    key: "Area",
    width: "w-44",
  },
];
const iecReferralsReportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Date",
    key: "Date",
    width: "md:w-20 lg:w-20 xl:w-24 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP_en",
    width: "md:w-24 lg:w-24 xl:w-28 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "AreaName_en",
    width: "md:w-24 lg:w-24 xl:w-32 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "No.(IPC/GD/ GMM/MED)",
    key: "IECNo",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "District",
    key: "District_en",
    width: "md:w-24 lg:w-28 xl:w-28 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Block",
    key: "Block_en",
    width: "md:w-24 lg:w-28 xl:w-28 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "City/Village",
    key: "City_en",
    width: "md:w-24 lg:w-28 xl:w-32 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Venue",
    key: "Venue",
    width: "md:w-24 lg:w-28 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Name of the participant",
    key: "BeneficiaryNameEn",
    width: "md:w-24 lg:w-28 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Age",
    key: "MstAgeId",
    width: "md:w-24 lg:w-24 xl:w-14 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Gender",
    key: "Gender_en",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Referral Service",
    key: "ReferredBy",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Referred to",
    key: "ReferredTo_en",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Received service (Y/N)",
    key: "ServiceReceived",
    width: "md:w-24 lg:w-28 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Followed-up date",
    key: "DateFollowedUp",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
  },
];

const iecIPCReportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Date",
    key: "OpeningDate",
    width: "md:w-20 lg:w-20 xl:w-24 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP_en",
    width: "md:w-24 lg:w-24 xl:w-28 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "AreaName_en",
    width: "md:w-24 lg:w-24 xl:w-32 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "IPC no.",
    key: "IPCno",
    width: "md:w-20 lg:w-20 xl:w-56 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "District",
    key: "District_en",
    width: "md:w-24 lg:w-28 xl:w-28 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Block",
    key: "Block_en",
    width: "md:w-24 lg:w-28 xl:w-28 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "City/Village",
    key: "City_en",
    width: "md:w-24 lg:w-28 xl:w-32 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Channel",
    key: "Channel",
    width: "md:w-24 lg:w-28 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Staff Name",
    key: "staffname",
    width: "md:w-24 lg:w-28 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Participants name",
    key: "ParticipantName_en",
    width: "md:w-24 lg:w-24 xl:w-40 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Age",
    key: "MstAgeId",
    width: "md:w-24 lg:w-24 xl:w-14 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Gender",
    key: "Gender_en",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T1: FP/MCH",
    key: "T1: FP/MCH",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T2: Abortion",
    key: "T2: Abortion",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T3: STI & HIV",
    key: "T3: STI & HIV",
    width: "md:w-24 lg:w-28 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T4: Adolescent Health",
    key: "T4: Adolescent Health",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T5: Infertility",
    key: "T5: Infertility",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T6: SRHR",
    key: "T6: SRHR",
    width: "md:w-24 lg:w-28 xl:w-48 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T7: GBV/RC",
    key: "T7: GBV/RC",
    width: "md:w-24 lg:w-28 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T8: Oral Cancer",
    key: "T8: Oral Cancer",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T9: Breast Cancer",
    key: "T9: Breast Cancer",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T10: Cervical cancer",
    key: "T10: Cervical cancer",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T11: HPV vaccination",
    key: "T11: HPV vaccination",
    width: "md:w-24 lg:w-28 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T12: MISP",
    key: "T12: MISP",
    width: "md:w-24 lg:w-28 xl:w-48 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T13: Non-Communicable Disease (NCD)",
    key: "T13: Non-Communicable Disease (NCD)",
    width: "md:w-24 lg:w-28 whitespace-pre-line  xl:w-36 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T14: Gender Identity & Sexual Orientation",
    key: "T14: Gender Identity & Sexual Orientation",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T15: Climate change & environment",
    key: "T15: Climate change & environment",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T16: Other",
    key: "T16: Other",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
  },
];

const iecMMReportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Date",
    key: "OpeningDate",
    width: "md:w-20 lg:w-20 xl:w-24 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP_en",
    width: "md:w-24 lg:w-24 xl:w-28 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "AreaName_en",
    width: "md:w-24 lg:w-24 xl:w-32 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "MED no.",
    key: "MMno",
    width: "md:w-20 lg:w-20 xl:w-56 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "District",
    key: "District_en",
    width: "md:w-24 lg:w-28 xl:w-28 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Block",
    key: "Block_en",
    width: "md:w-24 lg:w-28 xl:w-28 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "City/Village",
    key: "City_en",
    width: "md:w-24 lg:w-28 xl:w-32 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Venue",
    key: "Venue_en",
    width: "md:w-24 lg:w-28 xl:w-32 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Channel",
    key: "Channel",
    width: "md:w-24 lg:w-28 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T1: FP/MCH",
    key: "T1: FP/MCH",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T2: Abortion",
    key: "T2: Abortion",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T3: STI & HIV",
    key: "T3: STI & HIV",
    width: "md:w-24 lg:w-28 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T4: Adolescent Health",
    key: "T4: Adolescent Health",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T5: Infertility",
    key: "T5: Infertility",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T6: SRHR",
    key: "T6: SRHR",
    width: "md:w-24 lg:w-28 xl:w-48 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T7: GBV/RC",
    key: "T7: GBV/RC",
    width: "md:w-24 lg:w-28 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T8: Oral Cancer",
    key: "T8: Oral Cancer",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T9: Breast Cancer",
    key: "T9: Breast Cancer",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T10: Cervical cancer",
    key: "T10: Cervical cancer",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T11: HPV vaccination",
    key: "T11: HPV vaccination",
    width: "md:w-24 lg:w-28 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T12: MISP",
    key: "T12: MISP",
    width: "md:w-24 lg:w-28 xl:w-48 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T13: Non-Communicable Disease (NCD)",
    key: "T13: Non-Communicable Disease (NCD)",
    width: "md:w-24 lg:w-28 whitespace-pre-line  xl:w-36 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T14: Gender Identity & Sexual Orientation",
    key: "T14: Gender Identity & Sexual Orientation",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T15: Climate change & environment",
    key: "T15: Climate change & environment",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T16: Other",
    key: "T16: Other",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Mode",
    key: "Mode",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Type of media",
    key: "Type of media",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
];

const iecGDReportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Date",
    key: "OpeningDate",
    width: "md:w-20 lg:w-20 xl:w-24 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP_en",
    width: "md:w-24 lg:w-24 xl:w-28 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "AreaName_en",
    width: "md:w-24 lg:w-24 xl:w-32 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "GD no.",
    key: "GDno",
    width: "md:w-20 lg:w-20 xl:w-56 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "District",
    key: "District_en",
    width: "md:w-24 lg:w-28 xl:w-28 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Block",
    key: "Block_en",
    width: "md:w-24 lg:w-28 xl:w-28 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "City/Village",
    key: "City_en",
    width: "md:w-24 lg:w-28 xl:w-32 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Venue",
    key: "Venue_en",
    width: "md:w-24 lg:w-28 xl:w-32 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Channel",
    key: "Channel",
    width: "md:w-24 lg:w-28 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Staff Name",
    key: "staffname",
    width: "md:w-24 lg:w-28 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T1: FP/MCH",
    key: "T1: FP/MCH",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T2: Abortion",
    key: "T2: Abortion",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T3: STI & HIV",
    key: "T3: STI & HIV",
    width: "md:w-24 lg:w-28 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T4: Adolescent Health",
    key: "T4: Adolescent Health",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T5: Infertility",
    key: "T5: Infertility",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T6: SRHR",
    key: "T6: SRHR",
    width: "md:w-24 lg:w-28 xl:w-48 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T7: GBV/RC",
    key: "T7: GBV/RC",
    width: "md:w-24 lg:w-28 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T8: Oral Cancer",
    key: "T8: Oral Cancer",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T9: Breast Cancer",
    key: "T9: Breast Cancer",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T10: Cervical cancer",
    key: "T10: Cervical cancer",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T11: HPV vaccination",
    key: "T11: HPV vaccination",
    width: "md:w-24 lg:w-28 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T12: MISP",
    key: "T12: MISP",
    width: "md:w-24 lg:w-28 xl:w-48 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T13: Non-Communicable Disease (NCD)",
    key: "T13: Non-Communicable Disease (NCD)",
    width: "md:w-24 lg:w-28 whitespace-pre-line  xl:w-36 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T14: Gender Identity & Sexual Orientation",
    key: "T14: Gender Identity & Sexual Orientation",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T15: Climate change & environment",
    key: "T15: Climate change & environment",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T16: Other",
    key: "T16: Other",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
  },
  {
    title: "10-14yrs",
    key: "10-14yrs",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
    group: "Age",
  },
  {
    title: "15-24yrs",
    key: "15-24yrs",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
    group: "Age",
  },
  {
    title: "25+yrs",
    key: "25+yrs",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
    group: "Age",
  },
  {
    title: "Male",
    key: "male",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
    group: "Gender",
  },
  {
    title: "Female",
    key: "Female",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
    group: "Gender",
  },
  {
    title: "Other",
    key: "Others",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
    group: "Gender",
  },
  // {
  //   title: "Total no. of Participants",
  //   key: "NoOfPaticipantsTotal",
  //   width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  // },
];

const iecGMMReportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Date",
    key: "OpeningDate",
    width: "md:w-20 lg:w-20 xl:w-24 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP_en",
    width: "md:w-24 lg:w-24 xl:w-28 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "AreaName_en",
    width: "md:w-24 lg:w-24 xl:w-32 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "GMM no.",
    key: "GMMno",
    width: "md:w-20 lg:w-20 xl:w-60 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "District",
    key: "District_en",
    width: "md:w-24 lg:w-28 xl:w-28 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Block",
    key: "Block_en",
    width: "md:w-24 lg:w-28 xl:w-28 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "City/Village",
    key: "City_en",
    width: "md:w-24 lg:w-28 xl:w-32 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Venue",
    key: "Venue_en",
    width: "md:w-24 lg:w-28 xl:w-32 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Channel",
    key: "Channel",
    width: "md:w-24 lg:w-28 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Staff Name",
    key: "staffname",
    width: "md:w-24 lg:w-28 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T1: FP/MCH",
    key: "T1: FP/MCH",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T2: Abortion",
    key: "T2: Abortion",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T3: STI & HIV",
    key: "T3: STI & HIV",
    width: "md:w-24 lg:w-28 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T4: Adolescent Health",
    key: "T4: Adolescent Health",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T5: Infertility",
    key: "T5: Infertility",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T6: SRHR",
    key: "T6: SRHR",
    width: "md:w-24 lg:w-28 xl:w-48 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T7: GBV/RC",
    key: "T7: GBV/RC",
    width: "md:w-24 lg:w-28 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T8: Oral Cancer",
    key: "T8: Oral Cancer",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T9: Breast Cancer",
    key: "T9: Breast Cancer",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T10: Cervical cancer",
    key: "T10: Cervical cancer",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T11: HPV vaccination",
    key: "T11: HPV vaccination",
    width: "md:w-24 lg:w-28 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T12: MISP",
    key: "T12: MISP",
    width: "md:w-24 lg:w-28 xl:w-48 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T13: Non-Communicable Disease (NCD)",
    key: "T13: Non-Communicable Disease (NCD)",
    width: "md:w-24 lg:w-28 whitespace-pre-line  xl:w-36 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T14: Gender Identity & Sexual Orientation",
    key: "T14: Gender Identity & Sexual Orientation",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T15: Climate change & environment",
    key: "T15: Climate change & environment",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
  },
  {
    title: "T16: Other",
    key: "T16: Other",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
  },
  {
    title: "10-14yrs",
    key: "10-14yrs",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
    group: "Age",
  },
  {
    title: "15-24yrs",
    key: "15-24yrs",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
    group: "Age",
  },
  {
    title: "25+yrs",
    key: "25+yrs",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
    group: "Age",
  },
  {
    title: "Male",
    key: "male",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
    group: "Gender",
  },
  {
    title: "Female",
    key: "Female",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
    group: "Gender",
  },
  {
    title: "Other",
    key: "Others",
    width: "md:w-24 lg:w-28 xl:w-36 2xl:w-96 px-1 py-1.5",
    group: "Gender",
  },
];

const ageGenderDHIS2SRHReportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP_en",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "AreaName_en",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Services",
    key: "Services_en",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Project",
    key: "ProjectName_en",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "0-9 yrs Female",
    key: "FemaleAge0to9",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "0-9 yrs Male",
    key: "MaleAge0to9",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "0-9 yrs Others",
    key: "OtherAge0to9",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "10-14 Yrs Female",
    key: "FemaleAge10to14",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "10-14 Yrs Male",
    key: "MaleAge10to14",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "10-14 Yrs Others",
    key: "OtherAge10to14",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "15-19 Yrs Female",
    key: "FemaleAge15to19",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "15-19 Yrs Male",
    key: "MaleAge15to19",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "15-19 Yrs Others",
    key: "OtherAge15to19",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "20-24 Yrs Female",
    key: "FemaleAge20to24",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "20-24 Yrs Male",
    key: "MaleAge20to24",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "20-24 Yrs Others",
    key: "OtherAge20to24",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "25-29 Yrs Female",
    key: "FemaleAge25to29",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "25-29 Yrs Male",
    key: "MaleAge25to29",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "25-29 Yrs Others",
    key: "OtherAge25to29",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "30-34 Yrs Female",
    key: "FemaleAge30to34",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "30-34 Yrs Male",
    key: "MaleAge30to34",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "30-34 Yrs Others",
    key: "OtherAge30to34",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "35-39 Yrs Female",
    key: "FemaleAge35to39",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "35-39 Yrs Male",
    key: "MaleAge35to39",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "35-39 Yrs Others",
    key: "OtherAge35to39",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "40-44 Yrs Female",
    key: "FemaleAge40to44",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "40-44 Yrs Male",
    key: "MaleAge40to44",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "40-44 Yrs Others",
    key: "OtherAge40to44",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "45-49 Yrs Female",
    key: "FemaleAge45to49",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "45-49 Yrs Male",
    key: "MaleAge45to49",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "45-49 Yrs Others",
    key: "OtherAge45to49",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "50 Yrs and Above Female",
    key: "FemaleAge50andAbove",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "50 Yrs and Above Male",
    key: "MaleAge50andAbove",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "50 Yrs and Above Others",
    key: "OtherAge50andAbove",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
];
const ageGenderDonorSRHHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP_en",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "AreaName_en",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Services",
    key: "Services_en",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Project",
    key: "ProjectName_en",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "0-9 yrs Female",
    key: "FemaleAge0to9",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "0-9 yrs Male",
    key: "MaleAge0to9",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "0-9 yrs Others",
    key: "OtherAge0to9",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "10-14 Yrs Female",
    key: "FemaleAge10to14",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "10-14 Yrs Male",
    key: "MaleAge10to14",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "10-14 Yrs Others",
    key: "OtherAge10to14",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "15-18 Yrs Female",
    key: "FemaleAge15to18",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "15-18 Yrs Male",
    key: "MaleAge15to18",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "15-18 Yrs Others",
    key: "OtherAge15to18",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "19 Yrs Female",
    key: "FemaleAge19",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "19 Yrs Male",
    key: "MaleAge19",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "19 Yrs Others",
    key: "OtherAge19",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "20-24 Yrs Female",
    key: "FemaleAge20to24",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "20-24 Yrs Male",
    key: "MaleAge20to24",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "20-24 Yrs Others",
    key: "OtherAge20to24",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "25-29 Yrs Female",
    key: "FemaleAge25to29",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "25-29 Yrs Male",
    key: "MaleAge25to29",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "25-29 Yrs Others",
    key: "OtherAge25to29",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "30-34 Yrs Female",
    key: "FemaleAge30to34",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "30-34 Yrs Male",
    key: "MaleAge30to34",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "30-34 Yrs Others",
    key: "OtherAge30to34",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "35-39 Yrs Female",
    key: "FemaleAge35to39",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "35-39 Yrs Male",
    key: "MaleAge35to39",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "35-39 Yrs Others",
    key: "OtherAge35to39",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "40-44 Yrs Female",
    key: "FemaleAge40to44",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "40-44 Yrs Male",
    key: "MaleAge40to44",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "40-44 Yrs Others",
    key: "OtherAge40to44",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "45-49 Yrs Female",
    key: "FemaleAge45to49",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "45-49 Yrs Male",
    key: "MaleAge45to49",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "45-49 Yrs Others",
    key: "OtherAge45to49",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "50-59 Yrs Female",
    key: "FemaleAge50to59",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "50-59 Yrs Male",
    key: "MaleAge50to59",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "50-59 Yrs Others",
    key: "OtherAge50to59",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "60 Yrs and Above Female",
    key: "FemaleAge60AndAbove",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "60 Yrs and Above Male",
    key: "MaleAge60AndAbove",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "60 Yrs and Above Others",
    key: "OtherAge60AndAbove",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
];
const StockSDPHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "Date",
    key: "formatted_date",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP_en",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "AreaName_en",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Commodity Type",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Commodity Category",
    key: "CommodityCategory_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Commodity",
    key: "CommodityName_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Brand",
    key: "Brand_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Type",
    key: "TxnType",
    width: "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line  2xl:w-36 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Id",
    key: "TxnTypeId",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Batch No.",
    key: "BatchNo",
    width: "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line  2xl:w-36 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Expiry Date",
    key: "ExpiryDate",
    width: "md:w-24 lg:w-40 xl:w-24 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Recived By",
    key: "ReceivedBy",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Opening Stock",
    key: "OpeningQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Receipts",
    key: "ReceivedQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Issues",
    key: "IssuedQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Expired",
    key: "Expired",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Damaged",
    key: "Damaged",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Demo",
    key: "Demo",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Total Consumption",
    key: "TotalConsumption",
    width: "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-36 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Closing Stock",
    key: "BalanceQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
];
const StockReportBranchHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "Date",
    key: "formatted_date",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "Commodity Type",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Commodity Category",
    key: "CommodityCategory_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Commodity",
    key: "CommodityName_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Brand",
    key: "Brand_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Type",
    key: "TxnType",
    width: "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line  2xl:w-36 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Id",
    key: "TxnTypeId",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Batch No.",
    key: "BatchNo",
    width: "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line  2xl:w-36 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Expiry Date",
    key: "ExpiryDate",
    width: "md:w-24 lg:w-40 xl:w-24 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Recived By",
    key: "ReceivedBy",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Opening Stock",
    key: "OpeningQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Receipts",
    key: "ReceivedQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Issues",
    key: "IssuedQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Expired",
    key: "Expired",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Damaged",
    key: "Damaged",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Demo",
    key: "Demo",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Total Consumption",
    key: "TotalConsumption",
    width: "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-36 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Closing Stock",
    key: "BalanceQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
];
const StockReportORSHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "Date",
    key: "formatted_date",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP_en",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "AreaName_en",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "ORS",
    key: "ORS",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Commodity Type",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Commodity Category",
    key: "CommodityCategory_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Commodity",
    key: "CommodityName_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Brand",
    key: "Brand_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Type",
    key: "TxnType",
    width: "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line  2xl:w-36 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Id",
    key: "TxnTypeId",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Batch No.",
    key: "BatchNo",
    width: "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line  2xl:w-36 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Expiry Date",
    key: "ExpiryDate",
    width: "md:w-24 lg:w-40 xl:w-24 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Recived By",
    key: "ReceivedBy",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Opening Stock",
    key: "OpeningQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Receipts",
    key: "ReceivedQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Issues",
    key: "IssuedQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Expired",
    key: "Expired",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Damaged",
    key: "Damaged",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Demo",
    key: "Demo",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Total Consumption",
    key: "TotalConsumption",
    width: "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-36 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Closing Stock",
    key: "BalanceQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
];
const StockReportBranchLevelHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "Date",
    key: "formatted_date",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "Commodity Type",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Commodity Category",
    key: "CommodityCategory_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Commodity",
    key: "CommodityName_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Brand",
    key: "Brand_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "Opening Stock",
    key: "OpeningQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Receipts",
    key: "ReceivedQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Issues",
    key: "IssuedQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Expired",
    key: "Expired",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Damaged",
    key: "Damaged",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Demo",
    key: "Demo",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Total Consumption",
    key: "TotalConsumption",
    width: "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-36 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Closing Stock",
    key: "BalanceQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
];
const StockReportSDPLevelHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "Date",
    key: "formatted_date",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "SDP",
    key: "SDP_en",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "AreaName_en",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Commodity Type",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Commodity Category",
    key: "CommodityCategory_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Commodity",
    key: "CommodityName_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Brand",
    key: "Brand_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "Opening Stock",
    key: "OpeningQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Receipts",
    key: "ReceivedQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Issues",
    key: "IssuedQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Expired",
    key: "Expired",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Damaged",
    key: "Damaged",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Demo",
    key: "Demo",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Total Consumption",
    key: "TotalConsumption",
    width: "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-36 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Closing Stock",
    key: "BalanceQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
];
const StockReportORSLevelHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "Date",
    key: "formatted_date",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "SDP",
    key: "SDP_en",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "AreaName_en",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "ORS",
    key: "ORS",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Commodity Type",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Commodity Category",
    key: "CommodityCategory_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Commodity",
    key: "CommodityName_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Brand",
    key: "Brand_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "Opening Stock",
    key: "OpeningQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Receipts",
    key: "ReceivedQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Issues",
    key: "IssuedQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Expired",
    key: "Expired",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Damaged",
    key: "Damaged",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Demo",
    key: "Demo",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Total Consumption",
    key: "TotalConsumption",
    width: "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-36 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Closing Stock",
    key: "BalanceQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
];
const StockReportSDPHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Date",
    key: "formatted_date",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Commodity Type",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Commodity Category",
    key: "CommodityCategory_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Commodity",
    key: "CommodityName_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Brand",
    key: "Brand_en",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Type",
    key: "TxnType",
    width: "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line  2xl:w-36 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Id",
    key: "TxnTypeId",
    width: "md:w-40 lg:w-40 xl:w-44 whitespace-pre-line  2xl:w-44 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Opening Stock",
    key: "OpeningQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Receipts",
    key: "ReceivedQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Issues",
    key: "IssuedQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Expired",
    key: "Expired",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Damaged",
    key: "Damaged",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Demo",
    key: "Demo",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Total Consumption",
    key: "TotalConsumption",
    width: "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-36 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Closing Stock",
    key: "BalanceQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-24 px-1 py-1.5",
    width1: "text-red-600",
  },
];
const ageGenderChildrenReportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "Area",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Project",
    key: "Project",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Services",
    key: "Services_en",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Less than 1 yr Female",
    key: "FemaleLessthan1",
    width: "md:w-20 lg:w-20 xl:w-24 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Less than 1 yr Male",
    key: "MaleLessthan1",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Less than 1 yr Others",
    key: "OtherLessthan1",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "01-02 Yrs Female",
    key: "FemaleAge01to02",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "01-02 Yrs Male",
    key: "MaleAge01to02",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "01-02 Yrs Others",
    key: "OtherAge01to02",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "03-05 Yrs Female",
    key: "FemaleAge03to05",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "03-05 Yrs Male",
    key: "MaleAge03to05",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "03-05 Yrs Others",
    key: "OtherAge03to05",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "06 - 09 Yrs Female",
    key: "FemaleAge06to09",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "06 - 09 Yrs Male",
    key: "MaleAge06to09",
    width: "md:w-24 lg:w-28 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "06 - 09 Yrs Others",
    key: "OtherAge06to09",
    width: "md:w-24 lg:w-28 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "10 Yrs & Above Female",
    key: "FemaleAge10andAbove",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "10 Yrs & Above Male",
    key: "MaleAge10andAbove",
    width: "md:w-24 lg:w-28 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "10 Yrs & Above Others",
    key: "OtherAge10andAbove",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
];
const clientsByAgeGenderDHIS2SRHHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "Area",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Project",
    key: "Project",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Dataname",
    key: "dataname",
    width: "md:w-20 lg:w-20 xl:w-72 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Less than 10 Yrs Female",
    key: "Less_than_10_Yrs_Female",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Less than 10 Yrs Male",
    key: "Less_than_10_Yrs_Male",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Less than 10 Yrs Others",
    key: "Less_than_10_Yrs_Others",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "10-14 Yrs Female",
    key: "Female_10_14_Yrs",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "10-14 Yrs Male",
    key: "Male_10_14_Yrs",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "10-14 Yrs Others",
    key: "Others_10_14_Yrs",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "15-19 Yrs Female",
    key: "Female_15_19_Yrs",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "15-19 Yrs Male",
    key: "Male_15_19_Yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "15-19 Yrs Others",
    key: "Others_15_19_Yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "20-24 Yrs Female",
    key: "Female_20_24_Yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "20-24 Yrs Male",
    key: "Male_20_24_Yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "20-24 Yrs Others",
    key: "Others_20_24_Yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "25-29 Yrs Female",
    key: "Female_25_29_Yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "25_29_Yrs_Male",
    key: "Male_25_29_Yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "25-29 Yrs Others",
    key: "Others_25_29_Yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "30-34 Yrs Female",
    key: "Female_30_34_Yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "30-34 Yrs Male",
    key: "Male_30_34_Yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "30-34 Yrs Others",
    key: "Others_30_34_Yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "35-39 Yrs Female",
    key: "Female_35_39_Yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "35-39 Yrs Male",
    key: "Male_35_39_Yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "35-39 Yrs others",
    key: "Others_35_39_Yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "40-44 Yrs Female",
    key: "Female_40_44_Yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "40-44 Yrs Male",
    key: "Male_40_44_Yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "40-44 Yrs Others",
    key: "Others_40_44_Yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "45-49 Yrs Female",
    key: "Female_45_49_Yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "45-49 Yrs Male",
    key: "Male_45_49_Yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "45-49 Yrs Others",
    key: "Others_45_49_Yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "50 Yrs and Above Female",
    key: "Female_50_Yrs_and_Above",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "50 Yrs and Above Male",
    key: "Male_50_Yrs_and_Above",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "50 Yrs and Above Others",
    key: "Others_50_Yrs_and_Above",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
];

const clientsByAgeGenderDHIS2NonSRHHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "SDP",
    key: "SDP",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "Area",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Project",
    key: "Project",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Dataname",
    key: "Services_en",
    width: "md:w-20 lg:w-20 xl:w-72 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "0-24 yrs Female",
    key: "FemaleAge0to24",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line  2xl:w-40 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "0-24 yrs Male",
    key: "MaleAge0to24",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line  2xl:w-40 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "0-24 yrs Others",
    key: "OtherAge0to24",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line  2xl:w-40 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "25 Yrs and above Female",
    key: "FemaleAge24Above",
    width: "md:w-24 lg:w-24 xl:w-32 whitespace-pre-line 2xl:w-40 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "25 Yrs and above Male",
    key: "MaleAge24Above",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-40 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "25 Yrs and above Others",
    key: "OtherAge24Above",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-40 px-1 py-1.5",
  },
];

const clientsByAgeGenderDonorSRHHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "Area",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Project",
    key: "Project",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Dataname",
    key: "Dataname",
    width: "md:w-20 lg:w-20 xl:w-72 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "0-9 yrs Female",
    key: "FemaleAge0to9",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "0-9 yrs Male",
    key: "MaleAge0to9",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "0-9 yrs Others",
    key: "OtherAge0to9",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "10-14 Yrs Female",
    key: "FemaleAge10to14",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "10-14 Yrs Male",
    key: "MaleAge10to14",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "10-14 Yrs Others",
    key: "OtherAge10to14",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "15-18 Yrs Female",
    key: "FemaleAge15to18",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "15-18 Yrs Male",
    key: "MaleAge15to18",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "19 Yrs Others",
    key: "OtherAge19yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "19 Yrs Female",
    key: "FemaleAge19yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "19 Yrs Male",
    key: "MaleAge19yrs",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "15-18 Yrs Others",
    key: "OtherAge15to18",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "20-24 Yrs Female",
    key: "FemaleAge20to24",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "20-24 Yrs Male",
    key: "MaleAge20to24",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "20-24 Yrs Others",
    key: "OtherAge20to24",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "25-29 Yrs Female",
    key: "FemaleAge25to29",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "25-29 Yrs Male",
    key: "MaleAge25to29",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "25-29 Yrs Others",
    key: "OtherAge25to29",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "30-34 Yrs Female",
    key: "FemaleAge30to34",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "30-34 Yrs Male",
    key: "MaleAge30to34",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "30-34 Yrs Others",
    key: "OtherAge30to34",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "35-39 Yrs Female",
    key: "FemaleAge35to39",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "35-39 Yrs Male",
    key: "MaleAge35to39",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "35-39 Yrs Others",
    key: "OtherAge35to39",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "40-44 Yrs Female",
    key: "FemaleAge40to44",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "40-44 Yrs Male",
    key: "MaleAge40to44",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "40-44 Yrs Others",
    key: "OtherAge40to44",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "45-49 Yrs Female",
    key: "FemaleAge45to49",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "45-49 Yrs Male",
    key: "MaleAge45to49",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "45-49 Yrs Others",
    key: "OtherAge45to49",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "50-59 Yrs Female",
    key: "FemaleAge50to59",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "50-59 Yrs Male",
    key: "MaleAge50to59",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "50-59 Yrs Others",
    key: "OtherAge50to59",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "60 Yrs and Above Female",
    key: "FemaleAge60andAbove",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "60 Yrs and Above Male",
    key: "MaleAge60andAbove",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "60 Yrs and Above Others",
    key: "OtherAge60andAbove",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
];
const fpItemProvidedDHIS2SRHHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-56 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-56 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "Area",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-56 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Project",
    key: "Project",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Dataname",
    key: "PACServices_en",
    width: "md:w-20 lg:w-20 xl:w-72 whitespace-pre-line  2xl:w-72 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "0-9 yrs",
    key: "Age0to9",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-28 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "10-14 Yrs",
    key: "Age10to14",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line 2xl:w-28 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "15-19 Yrs",
    key: "Age15to19",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-28 px-1 py-1.5",
  },

  {
    title: "20-24 Yrs",
    key: "Age20to24",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line 2xl:w-28 px-1 py-1.5",
  },

  {
    title: "25-29 Yrs",
    key: "Age25to29",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-28 px-1 py-1.5",
  },

  {
    title: "30-34 Yrs",
    key: "Age30to34",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-28 px-1 py-1.5",
  },

  {
    title: "35-39 Yrs",
    key: "Age35to39",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-28 px-1 py-1.5",
  },

  {
    title: "40-44 Yrs",
    key: "Age40to44",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-28 px-1 py-1.5",
  },

  {
    title: "45-49 Yrs",
    key: "Age45to49",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-28 px-1 py-1.5",
  },

  {
    title: "50 Yrs and Above",
    key: "Age50andAbove",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-28 px-1 py-1.5",
  },
];

const clientsByAgeGenderChildrenHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "Area",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "Project",
    key: "Project",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Dataname",
    key: "Dataname",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Less than 1 yr Female",
    key: "FemaleLessthan1",
    width: "md:w-20 lg:w-20 xl:w-24 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Less than 1 yr Male",
    key: "MaleLessthan1",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Less than 1 yr Others",
    key: "OtherLessthan1",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "01-02 Yrs Female",
    key: "FemaleAge01to02",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "01-02 Yrs Male",
    key: "MaleAge01to02",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "01-02 Yrs Others",
    key: "OtherAge01to02",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "03-05 Yrs Female",
    key: "FemaleAge03to05",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "03-05 Yrs Male",
    key: "MaleAge03to05",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "03-05 Yrs Others",
    key: "OtherAge03to05",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "06 - 09 Yrs Female",
    key: "FemaleAge06to09",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "06 - 09 Yrs Male",
    key: "MaleAge06to09",
    width: "md:w-24 lg:w-28 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "06 - 09 Yrs Others",
    key: "OtherAge06to09",
    width: "md:w-24 lg:w-28 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "10 Yrs & Above Female",
    key: "FemaleAge10andAbove",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "10 Yrs & Above Male",
    key: "MaleAge10andAbove",
    width: "md:w-24 lg:w-28 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "10 Yrs & Above Others",
    key: "OtherAge10andAbove",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
];

const fpUserDHIS2SRHByAgeHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-56 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-56 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "Area",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-56 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Project",
    key: "Project",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Dataname",
    key: "PACServicesGrouped",
    width: "md:w-20 lg:w-20 xl:w-72 whitespace-pre-line  2xl:w-56 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "0-9 yrs",
    key: "Age0to9",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-28 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "10-14 Yrs",
    key: "Age10to14",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line 2xl:w-28 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "15-19 Yrs",
    key: "Age15to19",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-28 px-1 py-1.5",
  },

  {
    title: "20-24 Yrs",
    key: "Age20to24",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line 2xl:w-28 px-1 py-1.5",
  },

  {
    title: "25-29 Yrs",
    key: "Age25to29",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-28 px-1 py-1.5",
  },

  {
    title: "30-34 Yrs",
    key: "Age30to34",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-28 px-1 py-1.5",
  },

  {
    title: "35-39 Yrs",
    key: "Age35to39",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-28 px-1 py-1.5",
  },

  {
    title: "40-44 Yrs",
    key: "Age40to44",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-28 px-1 py-1.5",
  },

  {
    title: "45-49 Yrs",
    key: "Age45to49",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-28 px-1 py-1.5",
  },

  {
    title: "50 Yrs and Above",
    key: "Age50andAbove",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-28 px-1 py-1.5",
  },
];

const cypDHIS2SRHHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-60 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP_en",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-60 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "AreaName_en",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-60 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Dataname",
    key: "CYP",
    width: "md:w-20 lg:w-20 xl:w-72 whitespace-pre-line  2xl:w-72 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "0-9 yrs",
    key: "Age0to9",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-28 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "10-14 Yrs",
    key: "Age10to14",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line 2xl:w-28 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "15-19 Yrs",
    key: "Age15to19",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-28 px-1 py-1.5",
  },

  {
    title: "20-24 Yrs",
    key: "Age20to24",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line 2xl:w-28 px-1 py-1.5",
  },

  {
    title: "25-29 Yrs",
    key: "Age25to29",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-32 px-1 py-1.5",
  },

  {
    title: "30-34 Yrs",
    key: "Age30to34",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-32 px-1 py-1.5",
  },

  {
    title: "35-39 Yrs",
    key: "Age35to39",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-32 px-1 py-1.5",
  },

  {
    title: "40-44 Yrs",
    key: "Age40to44",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-32 px-1 py-1.5",
  },

  {
    title: "45-49 Yrs",
    key: "Age45to49",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-32 px-1 py-1.5",
  },

  {
    title: "50 Yrs and Above",
    key: "Age50andAbove",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-36 px-1 py-1.5",
  },
];

const KPYheaderData = [
  {
    title: "Performance",
    key: "Performance",
    width: "md:w-32 lg:w-28 xl:w-60 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Prev. year",
    key: "previous_year_count",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
  {
    title: "Current year",
    key: "current_year_count",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
];

const projectMasterHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-14 2xl:w-72 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "Branch/Project",
    key: "LocationName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Project",
    key: "ProjectName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
];

const CommodityCategoryHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-14 2xl:w-72 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "Commodity Type",
    key: "CommodityType_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Category",
    key: "CommodityCategory_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
];
const projectMasterExportHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-14 2xl:w-72 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "MstProjectId",
    key: "MstProjectId",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Branch/Project",
    key: "LocationName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ProjectName_en",
    key: "ProjectName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ProjectName_ta",
    key: "ProjectName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ProjectName_hi",
    key: "ProjectName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ProjectName_mr",
    key: "ProjectName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ProjectName_gu",
    key: "ProjectName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "ProjectName_kn",
    key: "ProjectName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ProjectName_ml",
    key: "ProjectName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },

  {
    title: "ProjectName_te",
    key: "ProjectName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ProjectName_bn",
    key: "ProjectName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "ProjectName_or",
    key: "ProjectName_en",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Created By",
    key: "FullName_en",
    width: " px-1 py-1.5 m-auto",
  },
];
const ageDonorSRHHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP_en",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "AreaName_en",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Services",
    key: "Services_en",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Project",
    key: "ProjectName_en",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "0-9 yrs",
    key: "Age0to9",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "10-14 Yrs",
    key: "Age10to14",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "15-18 Yrs",
    key: "Age15to18",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },

  {
    title: "19 Yrs",
    key: "Age19",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },

  {
    title: "20-24 Yrs",
    key: "Age20to24",
    width: "md:w-24 lg:w-24 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },

  {
    title: "25-29 Yrs",
    key: "Age25to29",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },

  {
    title: "30-34 Yrs",
    key: "Age30to34",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },

  {
    title: "35-39 Yrs",
    key: "Age35to39",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },

  {
    title: "40-44 Yrs",
    key: "Age40to44",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },

  {
    title: "45-49 Yrs",
    key: "Age45to49",
    width: "md:w-24 lg:w-28 xl:w-20 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },

  {
    title: "50-59 Yrs",
    key: "Age50to59",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },

  {
    title: "60 Yrs and Above",
    key: "Age60AndAbove",
    width: "md:w-24 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
];
const ageChildrenHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "Area",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Project",
    key: "Project",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Services",
    key: "Services_en",
    width: "md:w-44 lg:w-64 xl:w-72 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Less than 1 yr",
    key: "LessThan1Yr",
    width: "md:w-28 lg:w-20 xl:w-40 whitespace-pre-line  2xl:w-40 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "01-02 Yrs",
    key: "Age1to2",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line 2xl:w-40 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "03-05 Yrs",
    key: "Age3to5",
    width: "md:w-24 lg:w-28 xl:w-24 whitespace-pre-line 2xl:w-40 px-1 py-1.5",
  },

  {
    title: "06 - 09 Yrs",
    key: "Age6to9",
    width: "md:w-24 lg:w-28 xl:w-36 whitespace-pre-line 2xl:w-40 px-1 py-1.5",
  },

  {
    title: "10 Yrs & Above",
    key: "Age10AndAbove",
    width: "md:w-28 lg:w-24 xl:w-36 whitespace-pre-line 2xl:w-40 px-1 py-1.5",
  },
];

const ageDHIS2SRHHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-14 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP_en",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "AreaName_en",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Services",
    key: "Services_en",
    width: "md:w-20 lg:w-20 xl:w-72 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Project",
    key: "ProjectName_en",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "0-9 yrs",
    key: "Age0to9",
    width: "md:w-20 lg:w-20 xl:w-24 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "10-14 Yrs",
    key: "Age10to14",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "15-19 Yrs",
    key: "Age15to19",
    width: "md:w-24 lg:w-28 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },

  {
    title: "20-24 Yrs",
    key: "Age20to24",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },

  {
    title: "25-29 Yrs",
    key: "Age25to29",
    width: "md:w-24 lg:w-28 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },

  {
    title: "30-34 Yrs",
    key: "Age30to34",
    width: "md:w-24 lg:w-28 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },

  {
    title: "35-39 Yrs",
    key: "Age35to39",
    width: "md:w-24 lg:w-28 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },

  {
    title: "40-44 Yrs",
    key: "Age40to44",
    width: "md:w-24 lg:w-28 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },

  {
    title: "45-49 Yrs",
    key: "Age45to49",
    width: "md:w-24 lg:w-28 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },

  {
    title: "50 Yrs and Above",
    key: "Age50AndAbove",
    width: "md:w-24 lg:w-28 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
  },
];

const reportGenderHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-14 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP_en",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "AreaName_en",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Services",
    key: "Services_en",
    width: "md:w-72 lg:w-72 xl:w-96 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Project",
    key: "ProjectName_en",
    width: "md:w-20 lg:w-20 xl:w-44 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Female",
    key: "Female",
    width: "md:w-32 lg:w-32 xl:w-32 2xl:w-32 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "Male",
    key: "Male",
    width: "md:w-32 lg:w-32 xl:w-32  2xl:w-32 px-1 py-1.5",
    width1: "text-red-600",
  },

  {
    title: "Others",
    key: "Others",
    width: "md:w-32 lg:w-32 xl:w-32 2xl:w-32 px-1 py-1.5",
  },
];

const IECSummaryHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-60 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "SDP",
    key: "SDP_en",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-60 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Area",
    key: "AreaName_en",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-60 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Type of topic/ subject",
    key: "Typeoftopicsubject",
    width: "md:w-32 lg:w-32 xl:w-44 whitespace-pre-line  2xl:w-60 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Gender/Age",
    key: "GenderAge",
    width: "md:w-32 lg:w-32 xl:w-56 whitespace-pre-line  2xl:w-60 px-1 py-1.5",
    width1: "text-red-600",
    group: "Interpersonal contact (1-4 persons)",
  },
  {
    title: "10-14 Years",
    key: "tentoYears",
    width: "md:w-32 lg:w-32 xl:w-56 whitespace-pre-line 2xl:w-60 px-1 py-1.5",
    width1: "text-red-600",
    group: "Interpersonal contact (1-4 persons)",
  },
  {
    title: "15-24 Years",
    key: "fifteentoYears",
    width: "md:w-32 lg:w-32 xl:w-56 2xl:w-60 whitespace-pre-line px-1 py-1.5",
    width1: "text-red-600",
    group: "Interpersonal contact (1-4 persons)",
  },
  {
    title: " 25+ Years",
    key: "twentyfivetoYears",

    width: "md:w-32 lg:w-32 xl:w-56 whitespace-pre-line 2xl:w-60 px-1 py-1.5",
    group: "Interpersonal contact (1-4 persons)",
  },
  {
    title: "Events",
    key: "GroupDiscussionsEvents",

    width: "md:w-32 lg:w-32 xl:w-40 whitespace-pre-line 2xl:w-60 px-1 py-1.5",
    group: "Group discussions (5-20 persons)",
  },
  {
    title: "Participants",
    key: "GDParticipants",

    width: "md:w-32 lg:w-32 xl:w-36 whitespace-pre-line 2xl:w-60 px-1 py-1.5",
    group: "Group discussions (5-20 persons)",
  },
  {
    title: "Events",
    key: "GeneralMassEvents",
    group: "General / Mass meetings (21+persons)",
    width: "md:w-32 lg:w-32 xl:w-36 whitespace-pre-line 2xl:w-60 px-1 py-1.5",
  },
  {
    title: "Participants",
    key: "GMMParticipants",
    group: "General / Mass meetings (21+persons)",
    width: "md:w-32 lg:w-32 xl:w-56 whitespace-pre-line 2xl:w-60 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Events",
    key: "MassMediaEvents",
    width: "md:w-32 lg:w-32 xl:w-24 2xl:w-60 px-1 py-1.5",
    width1: "text-red-600",
    group: "Mass media/Supporting activities",
  },
  {
    title: "Participants",
    key: "MMParticipants",
    width: "md:w-32 lg:w-32 xl:w-24 2xl:w-60 px-1 py-1.5",
    group: "Mass media/Supporting activities",
  },
];

const CSESummaryHeader = [
  {
    title: "S.No. ",
    key: "RowNumber",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-18 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Branch",
    key: "Branch",
    width: "md:w-20 lg:w-20 xl:w-36 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Module Name",
    key: "ModuleName",
    width: "md:w-20 lg:w-20 xl:w-72 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "Gender",
    key: "Gender",
    width: "md:w-24 whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
  {
    title: "10-14",
    key: "InSchool_10_14",
    width: "md:w-24  whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
    group: "A. In School/College",
  },
  {
    title: "15-19",
    key: "InSchool_15_19",
    width: "md:w-24  whitespace-pre-line px-1 py-1.5",
    width1: "text-red-600",
    group: "A. In School/College",
  },
  {
    title: "20-24",
    key: "InSchool_20_24",
    width: "md:w-24  xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    group: "A. In School/College",
  },
  {
    title: "10-14",
    key: "OutOfSchool_10_14",
    width: "md:w-24  whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
    group: "B. Out of School youth",
  },
  {
    title: "15-19",
    key: "OutOfSchool_15_19",
    width: "md:w-24  whitespace-pre-line px-1 py-1.5",
    width1: "text-red-600",
    group: "B. Out of School youth",
  },
  {
    title: "20-24",
    key: "OutOfSchool_20_24",
    width: "md:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    group: "B. Out of School youth",
  },

  {
    title: "Cumulative",
    key: "Cumulative",
    width: "md:w-20  whitespace-pre-line  2xl:w-96 px-1 py-1.5",
    width1: "text-red-600",
  },
];

const staffNameHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "State",
    key: "StateName_en",
    width: "md:w-40 lg:w-40 xl:w-60 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Branch / Project",
    key: "LocationName_en",
    width: "md:w-44 lg:w-44 xl:w-60 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Staff Name",
    key: "StaffName_en",
    width: "md:w-44 lg:w-60 xl:w-72 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5 ",
  },
];
const staffNameExportHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "MstStaffNameId",
    key: "MstStaffNameId",
    width: "md:w-40 lg:w-40 xl:w-60 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "State",
    key: "StateName_en",
    width: "md:w-40 lg:w-40 xl:w-60 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Branch / Project",
    key: "LocationName_en",
    width: "md:w-44 lg:w-44 xl:w-60 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "StaffName_en",
    key: "StaffName_en",
    width: "md:w-44 lg:w-60 xl:w-72 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "StaffName_ta",
    key: "StaffName_en",
    width: "md:w-44 lg:w-60 xl:w-72 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "StaffName_hi",
    key: "StaffName_en",
    width: "md:w-44 lg:w-60 xl:w-72 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "StaffName_mr",
    key: "StaffName_en",
    width: "md:w-44 lg:w-60 xl:w-72 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "StaffName_gu",
    key: "StaffName_en",
    width: "md:w-44 lg:w-60 xl:w-72 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "StaffName_kn",
    key: "StaffName_en",
    width: "md:w-44 lg:w-60 xl:w-72 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "StaffName_ml",
    key: "StaffName_en",
    width: "md:w-44 lg:w-60 xl:w-72 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "StaffName_te",
    key: "StaffName_en",
    width: "md:w-44 lg:w-60 xl:w-72 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "StaffName_bn",
    key: "StaffName_en",
    width: "md:w-44 lg:w-60 xl:w-72 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "StaffName_or",
    key: "StaffName_en",
    width: "md:w-44 lg:w-60 xl:w-72 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Created By",
    key: "FullName_en",
    width: " px-1 py-1.5 ",
  },
];
const contraceptiveExcelExportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "MstCommoditiesId",
    key: "MstCommoditiesId",
    width: "md:w-44 lg:w-48 2xl:w-48 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Contraceptive Categories",
    key: "CommodityCategory_en",
    width: "md:w-44 lg:w-48 2xl:w-48 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_en",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_ta",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_hi",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_mr",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_gu",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "CommodityName_kn",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_ml",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "CommodityName_te",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_bn",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_or",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Description_en",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_ta",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_hi",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_mr",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_gu",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Description_kn",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_ml",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Description_te",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_bn",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_or",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Unit Of Measure",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Item Category",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "SDP Level",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Outreach level",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Branch level",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Created By",
    key: "action",
    width: "px-1 py-1.5 2xl:m-auto",
  },
];
const socialMarketingExcelExportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "MstCommoditiesId",
    key: "MstCommoditiesId",
    width: "md:w-44 lg:w-48 2xl:w-48 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Social Marketing Categories",
    key: "CommodityCategory_en",
    width: "md:w-44 lg:w-48 2xl:w-48 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_en",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_ta",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_hi",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_mr",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_gu",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "CommodityName_kn",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_ml",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_te",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_bn",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_or",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Description_en",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_ta",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_hi",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_mr",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_gu",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Description_kn",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_ml",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Description_te",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_bn",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_or",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Unit Of Measure",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Item Category",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "SDP Level",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Outreach level",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Branch level",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Created By",
    key: "action",
    width: "px-1 py-1.5 2xl:m-auto",
  },
];
const medicinesDrugsExcelExportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "MstCommoditiesId",
    key: "MstCommoditiesId",
    width: "md:w-44 lg:w-48 2xl:w-48 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Medicines / Drugs Categories",
    key: "CommodityCategory_en",
    width: "md:w-44 lg:w-48 2xl:w-48 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_en",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_ta",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_hi",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_mr",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_gu",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_kn",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_ml",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_te",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_bn",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_or",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Route",
    key: "Route",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Description_en",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_ta",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_hi",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_mr",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_gu",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Description_kn",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_ml",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Description_te",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_bn",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_or",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Unit Of Measure",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Item Category",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "SDP Level",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Outreach level",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Branch level",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Created By",
    key: "action",
    width: "px-1 py-1.5 2xl:m-auto",
  },
];
const consumablesExcelExportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "MstCommoditiesId",
    key: "MstCommoditiesId",
    width: "md:w-44 lg:w-48 2xl:w-48 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Consumables Categories",
    key: "CommodityCategory_en",
    width: "md:w-44 lg:w-48 2xl:w-48 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_en",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_ta",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_hi",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_mr",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_gu",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "CommodityName_kn",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_ml",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "CommodityName_te",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_bn",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "CommodityName_or",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Description_en",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_ta",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_hi",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_mr",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_gu",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Description_kn",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_ml",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Description_te",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_bn",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description_or",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Unit Of Measure",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Item Category",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "SDP Level",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Outreach level",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Branch level",
    key: "Description_en",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Created By",
    key: "action",
    width: "px-1 py-1.5 2xl:m-auto",
  },
];
const brandExcelExportHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "MstBrandId",
    key: "MstBrandId",
    width: "md:w-40 lg:w-40 xl:w-60 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Commodities",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-40 xl:w-60 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Category",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-40 xl:w-60 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Name",
    key: "CommodityName_en",
    width: "md:w-44 lg:w-44 xl:w-60 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Brand_en",
    key: "Brand_en",
    width: "md:w-44 lg:w-60 xl:w-72 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Brand_ta",
    key: "Brand_en",
    width: "md:w-44 lg:w-60 xl:w-72 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Brand_hi",
    key: "Brand_en",
    width: "md:w-44 lg:w-60 xl:w-72 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Brand_mr",
    key: "Brand_en",
    width: "md:w-44 lg:w-60 xl:w-72 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Brand_gu",
    key: "Brand_en",
    width: "md:w-44 lg:w-60 xl:w-72 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Brand_kn",
    key: "Brand_en",
    width: "md:w-44 lg:w-60 xl:w-72 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Brand_ml",
    key: "Brand_en",
    width: "md:w-44 lg:w-60 xl:w-72 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Brand_te",
    key: "Brand_en",
    width: "md:w-44 lg:w-60 xl:w-72 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Brand_bn",
    key: "Brand_en",
    width: "md:w-44 lg:w-60 xl:w-72 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Brand_or",
    key: "Brand_en",
    width: "md:w-44 lg:w-60 xl:w-72 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Created By",
    key: "Created",
    width: " px-1 py-1.5 ",
  },
];
const openingStockExcelExportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-24 px-1 py-1.5  ",
  },

  {
    title: "MstOpeningStockId",
    key: "MstOpeningStockId",
    width: "md:w-40 lg:w-36 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },

  {
    title: "Commodities",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-36 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Entity",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-36 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Branch/Project",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-36 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "S.D.P.",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-36 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Area Name",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-36 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Outreach staff",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-36 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Category",
    key: "CommodityCategory_en",
    width: "md:w-44 lg:w-44 xl:w-52 2xl:m-auto px-1 py-1.5 mr-auto",
  },
  {
    title: "Name",
    key: "CommodityName_en",
    width: "md:w-44 lg:w-44 xl:w-52 2xl:m-auto px-1 py-1.5 mr-auto",
  },
  {
    title: "Brand",
    key: "Brand_en",
    width: "md:w-28 lg:w-28 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Batch",
    key: "Brand_en",
    width: "md:w-28 lg:w-28 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Exp. Date",
    key: "Brand_en",
    width: "md:w-28 lg:w-28 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Opening Quantity",
    key: "Brand_en",
    width: "md:w-28 lg:w-28 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },

  {
    title: "U.O.M",
    key: "CommodityUOM",
    width: "md:w-18 lg:w-18 xl:w-24 2xl:m-auto px-1 py-1.5 mr-auto",
  },
  {
    title: "Value",
    key: "CommodityUOM",
    width: "md:w-18 lg:w-18 xl:w-24 2xl:m-auto px-1 py-1.5 mr-auto",
  },
  {
    title: "Created By",
    key: "Created",
    width: "px-1 py-1.5 2xl:m-auto",
  },
];
const supplierMasterExcelExportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-12 xl:w-12 2xl:w-24 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "MstSupplierId",
    key: "MstSupplierId",
    width: "md:w-28 lg:w-24 xl:w-36 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Supplier Id",
    key: "SupplierId",
    width: "md:w-28 lg:w-24 xl:w-36 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Supplier Name",
    key: "SupplierName",
    width: "md:w-32 lg:w-32 xl:w-44 2xl:m-auto 2xl:w-60 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Address",
    key: "SupplierLogo",
    width: "md:w-16 lg:w-16 xl:w-24 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Country",
    key: "SupplierLogo",
    width: "md:w-16 lg:w-16 xl:w-24 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "State",
    key: "SupplierLogo",
    width: "md:w-16 lg:w-16 xl:w-24 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "City",
    key: "LocationName_en",
    width: "md:w-24 lg:w-24 xl:w-36 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Pin Code",
    key: "SupplierLogo",
    width: "md:w-16 lg:w-16 xl:w-24 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "SupplierLogo",
    width: "md:w-16 lg:w-16 xl:w-24 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Logo",
    key: "SupplierLogo",
    width: "md:w-16 lg:w-16 xl:w-24 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Contact Person",
    key: "SupplierLogo",
    width: "md:w-16 lg:w-16 xl:w-24 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Designation",
    key: "SupplierLogo",
    width: "md:w-16 lg:w-16 xl:w-24 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Contact Number",
    key: "SupplierMobileNumber",
    width: "md:w-24 lg:w-24 xl:w-36 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Email",
    key: "SupplierEmailId",
    width: "md:w-32 lg:w-28 xl:w-60 2xl:m-auto 2xl:w-48 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Created By",
    key: "Created",
    width: "px-1 py-1.5 ",
  },
];

const userExcelExportHeaders = [
  {
    title: "S.No.",
    width: "md:w-10 lg:w-10 xl:w-12 2xl:w-14 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "MstUserId",
    key: "MstUserId",
    width: "md:w-24 lg:w-24 xl:w-40 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "FirstName_en",
    key: "FirstName_en",
    width: "md:w-24 lg:w-24 xl:w-40 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "FirstName_ta",
    key: "FirstName_en",
    width: "md:w-24 lg:w-24 xl:w-40 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "FirstName_hi",
    key: "FirstName_en",
    width: "md:w-24 lg:w-24 xl:w-40 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "FirstName_mr",
    key: "FirstName_en",
    width: "md:w-24 lg:w-24 xl:w-40 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "FirstName_gu",
    key: "FirstName_en",
    width: "md:w-24 lg:w-24 xl:w-40 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "FirstName_kn",
    key: "FirstName_en",
    width: "md:w-24 lg:w-24 xl:w-40 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "FirstName_ml",
    key: "FirstName_en",
    width: "md:w-24 lg:w-24 xl:w-40 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "FirstName_te",
    key: "FirstName_en",
    width: "md:w-24 lg:w-24 xl:w-40 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "FirstName_bn",
    key: "FirstName_en",
    width: "md:w-24 lg:w-24 xl:w-40 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "FirstName_or",
    key: "FirstName_en",
    width: "md:w-24 lg:w-24 xl:w-40 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "MiddleName_en",
    key: "MiddleName_en",
    width: "md:w-24 lg:w-24 xl:w-32 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "MiddleName_ta",
    key: "MiddleName_en",
    width: "md:w-24 lg:w-24 xl:w-32 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "MiddleName_hi",
    key: "MiddleName_en",
    width: "md:w-24 lg:w-24 xl:w-32 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "MiddleName_mr",
    key: "MiddleName_en",
    width: "md:w-24 lg:w-24 xl:w-32 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "MiddleName_gu",
    key: "MiddleName_en",
    width: "md:w-24 lg:w-24 xl:w-32 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "MiddleName_kn",
    key: "MiddleName_en",
    width: "md:w-24 lg:w-24 xl:w-32 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "MiddleName_ml",
    key: "MiddleName_en",
    width: "md:w-24 lg:w-24 xl:w-32 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "MiddleName_te",
    key: "MiddleName_en",
    width: "md:w-24 lg:w-24 xl:w-32 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "MiddleName_bn",
    key: "MiddleName_en",
    width: "md:w-24 lg:w-24 xl:w-32 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "MiddleName_or",
    key: "MiddleName_en",
    width: "md:w-24 lg:w-24 xl:w-32 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "LastName_en",
    key: "LastName_en",
    width: "md:w-32 lg:w-36 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "LastName_ta",
    key: "LastName_en",
    width: "md:w-32 lg:w-36 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "LastName_hi",
    key: "LastName_en",
    width: "md:w-32 lg:w-36 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "LastName_mr",
    key: "LastName_en",
    width: "md:w-32 lg:w-36 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "LastName_gu",
    key: "LastName_en",
    width: "md:w-32 lg:w-36 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "LastName_kn",
    key: "LastName_en",
    width: "md:w-32 lg:w-36 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "LastName_ml",
    key: "LastName_en",
    width: "md:w-32 lg:w-36 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "LastName_te",
    key: "LastName_en",
    width: "md:w-32 lg:w-36 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "LastName_bn",
    key: "LastName_en",
    width: "md:w-32 lg:w-36 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "LastName_or",
    key: "LastName_en",
    width: "md:w-32 lg:w-36 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Email",
    key: "UserMobile",
    width: "md:w-28 lg:w-24 xl:w-36 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Mobile Number",
    key: "Designation",
    width: "md:w-28 lg:w-24 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Designation",
    key: "RoleName",
    width: "md:w-28 lg:w-24 xl:w-32 2xl:w-96 px-1 py-1.5 mr-auto ",
    width1: "text-red-500",
  },
  {
    title: "Role/Groups",
    key: "action",
    width: " px-1 py-1.5  ",
  },
  {
    title: "Organization Structure",
    key: "action",
    width: " px-1 py-1.5  ",
  },
  {
    title: "State",
    key: "action",
    width: " px-1 py-1.5  ",
  },
  {
    title: "Branch/Project",
    key: "action",
    width: " px-1 py-1.5  ",
  },
  {
    title: "S.D.P.",
    key: "action",
    width: " px-1 py-1.5  ",
  },
  {
    title: "File Upload",
    key: "action",
    width: " px-1 py-1.5  ",
  },
  {
    title: "Created",
    key: "action",
    width: " px-1 py-1.5  ",
  },
];
const roleMasterExcelExportHeader = [
  {
    title: "S.No.",
    key: "MstRoleId",
    width: "md:w-12 2xl:w-12 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "MstRoleId",
    key: "MstRoleId",
    width: "md:w-12 2xl:w-12 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "Role / Group",
    key: "RoleName",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Description",
    key: "RoleDiscription",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Created By",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
];

const contraceptivesGivenHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-24 px-1 py-1.5  ",
  },
  {
    title: "Date",
    key: "DateFORMAT",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Entity",
    key: "EntityName",
    width: "md:w-32 lg:w-32 xl:w-32 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Commodities",
    key: "CommodityType_en",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Category",
    key: "CommodityCategory_en",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Name",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:m-auto px-1 py-1.5",
  },
  {
    title: "Brand",
    key: "Brand_en",
    width: "md:w-28 lg:w-28 xl:w-28 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Exp. Date",
    key: "ExpiryDateFORMAT",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Quantity",
    key: "Quantity",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "U.O.M",
    key: "CommodityUOM",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5 2xl:m-auto",
  },
];
const contraceptivesGivenExcelExportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-24 px-1 py-1.5  ",
  },

  {
    title: "MstContraceptivesGivenId",
    key: "MstContraceptivesGivenId",
    width: "md:w-40 lg:w-36 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Date",
    key: "Date",
    width: "md:w-40 lg:w-36 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Month",
    key: "MonthName",
    width: "md:w-40 lg:w-36 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },

  {
    title: "Year",
    key: "Year",
    width: "md:w-40 lg:w-36 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },

  {
    title: "Commodities",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-36 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Entity",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-36 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Branch/Project",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-36 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "S.D.P.",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-36 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Area Name",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-36 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Outreach staff",
    key: "CommodityType_en",
    width: "md:w-40 lg:w-36 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Category",
    key: "CommodityCategory_en",
    width: "md:w-44 lg:w-44 xl:w-52 2xl:m-auto px-1 py-1.5 mr-auto",
  },
  {
    title: "Name",
    key: "CommodityName_en",
    width: "md:w-44 lg:w-44 xl:w-52 2xl:m-auto px-1 py-1.5 mr-auto",
  },
  {
    title: "Brand",
    key: "Brand_en",
    width: "md:w-28 lg:w-28 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Batch",
    key: "Brand_en",
    width: "md:w-28 lg:w-28 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Exp. Date",
    key: "Brand_en",
    width: "md:w-28 lg:w-28 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Quantity",
    key: "Brand_en",
    width: "md:w-28 lg:w-28 xl:w-48 2xl:m-auto px-1 py-1.5 ",
  },

  {
    title: "U.O.M",
    key: "CommodityUOM",
    width: "md:w-18 lg:w-18 xl:w-24 2xl:m-auto px-1 py-1.5 mr-auto",
  },
  {
    title: "Value",
    key: "Charges",
    width: "md:w-18 lg:w-18 xl:w-24 2xl:m-auto px-1 py-1.5 mr-auto",
  },
  {
    title: "Created By",
    key: "Created",
    width: "px-1 py-1.5 2xl:m-auto",
  },
];

const contraceptivesGivenRePortHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-24 px-1 py-1.5  ",
  },

  {
    title: "Date",
    key: "Date",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Month",
    key: "MonthName",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:m-auto px-1 py-1.5 ",
  },

  {
    title: "Year",
    key: "Year",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:m-auto px-1 py-1.5 ",
  },

  {
    title: "Entity",
    key: "EntityName",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Branch/Project",
    key: "LocationName_en",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "S.D.P.",
    key: "SDP_en",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Area Name",
    key: "AreaName_en",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Outreach staff",
    key: "OutreachStaff",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Commodities",
    key: "CommodityType_en",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Category",
    key: "CommodityCategory_en",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:m-auto px-1 py-1.5  ",
  },
  {
    title: "Name",
    key: "CommodityName_en",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:m-auto px-1 py-1.5  ",
  },
  {
    title: "Brand",
    key: "Brand_en",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Batch",
    key: "Batch",
    width: "md:w-28 lg:w-28 xl:w-28 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Exp. Date",
    key: "ExpiryDate",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:m-auto px-1 py-1.5 ",
  },
  {
    title: "Quantity",
    key: "Quantity",
    width: "md:w-28 lg:w-28 xl:w-28 2xl:m-auto px-1 py-1.5 ",
  },

  {
    title: "U.O.M",
    key: "CommodityUOM",
    width: "md:w-18 lg:w-18 xl:w-24 2xl:m-auto px-1 py-1.5 mr-auto",
  },
  {
    title: "Value",
    key: "Charges",
    width: "md:w-18 lg:w-18 xl:w-24 2xl:m-auto px-1 py-1.5 mr-auto",
  },
  {
    title: "Created By",
    key: "CreatedBy",
    width: "px-1 py-1.5 2xl:m-auto",
  },
];
export {
  contraceptivesGivenHeader,
  iecExcelExportHeader,
  iecGDExcelExportHeader,
  iecGMMExcelExportHeader,
  iecMMExcelExportHeader,
  servicesExcelExportHeader,
  contraceptivesGivenExcelExportHeader,
  referralService,
  ReferedTo,
  AwarenessGender,
  ReferralServiceCSE,
  AwarenessAge,
  ServicesName,
  countryMasterHeader,
  stateMasterHeader,
  areaMasterHeader,
  locationMasterHeader,
  languageMasterHeader,
  languageMasterExportHeader,
  userHeaders,
  clientHeaders,
  roleMasterHeader,
  campsMeetingsMasterHeader,
  healthCareHeaders,
  healthCareExportHeaders,
  inventoryProductHeader,
  schoolMasterHeaders,
  schoolMasterExportHeaders,
  studentMasterHeaders,
  appointmentHeaders,
  inventoryIssueHeaders,
  eventMasterHeaders,
  EducationMaterialMasterHeaders,
  cseInSchoolHeaders,
  cseOutSchoolHeaders,
  outOfSchoolYouthHeaders,
  inventoryReceiptsHeaders,
  NonSRHProductsMasterHeaders,
  SRHCommoditiesMasterHeaders,
  ServicesClientHeaders,
  inventoryReceiptsViewHeaders,
  inventoryIndentHeaders,
  ResourcesMasterHeader,
  ResourcesMasterExportHeader,
  servicesCategoryHeaders,
  servicesSubCategoryHeaders,
  servicesMasterHeaders,
  servicesMasterExportHeaders,
  sdpMasterHeader,
  studentDetailsHeaders,
  BrochureMasterHeader,
  BrochureMasterExportHeader,
  ServicesHeadersData,
  AwarenessHeader,
  YouthHeader,
  ServicesAddHeader,
  youthGroupMasterHeaders,
  youthGroupMasterExportHeaders,
  roleVsCapabilityHeader,
  doctorAppoinmentsHeaders,
  supplierMasterHeader,
  spServiceSessionMasterHeaders,
  eventRegisterHeaders,
  InterPersonalContactHeader,
  GroupDiscussionHeaders,
  GeneralMassMeetingHeaders,
  MassMediaHeaders,
  OutSchoolHeaders,
  SingleSessionOnlineHeader,
  SingleSessionHeader,
  SpecialServiceSessionHeader,
  contraceptiveHeader,
  socialMarketingHeader,
  medicinesDrugsHeader,
  pendingIndentHeader,
  cseHeaders,
  PartnerOrganizationHeader,
  inschoolsessionStudentHeader,
  CBPHeader,
  brandHeaders,
  ReportInschoolSession,
  inventoryIssueDetailsHeaders,
  indentDetailsHeader,
  issueDetailsHeader,
  issueDetailsEditHeader,
  issueIndentDetailsHeader,
  issueIndentDetailsEditHeader,
  issueDetailsHeaderPopup,
  ServicesHeaders,
  consumptionHeaders,
  excelExportReferralTrackingHeaders,
  consumablesHeader,
  ReferralFollowUpNotificationsHeader,
  issueDetailsPopUpHeader,
  ReferralTrackingHeaders,
  clientChildrenDetailsHeaders,
  contraceptiveRSFHeader,
  openingStockHeader,
  ConsumptionViewHeaders,
  districtMasterHeader,
  blockMasterHeader,
  cityvillageMasterHeader,
  inventoryDirectIssueHeaders,
  CSEInSchoolReportHeader,
  projectMasterHeaders,
  projectMasterExportHeaders,
  CSEOutSchoolReportHeader,
  CSEReferralsReportHeader,
  DropoutsReportHeader,
  iecReferralsReportHeader,
  iecIPCReportHeader,
  iecMMReportHeader,
  iecGDReportHeader,
  iecGMMReportHeader,
  ProfileCATClientsReportHeader,
  ProfilePACReportHeader,
  ClientProfileMEReportHeader,
  ageGenderDHIS2SRHReportHeader,
  ageGenderChildrenReportHeader,
  clientsByAgeGenderDHIS2SRHHeader,
  clientsByAgeGenderDonorSRHHeader,
  fpItemProvidedDHIS2SRHHeader,
  clientsByAgeGenderChildrenHeader,
  fpUserDHIS2SRHByAgeHeader,
  cypDHIS2SRHHeader,
  KPYheaderData,
  ageGenderDonorSRHHeader,
  ageDonorSRHHeader,
  SingleSessionReportHeader,
  ageChildrenHeader,
  ageDHIS2SRHHeader,
  MonthlyEventsReportHeader,
  reportGenderHeader,
  clientsByAgeGenderDHIS2NonSRHHeader,
  StockReportBranchHeader,
  IECSummaryHeader,
  StockReportSDPHeader,
  CSESummaryHeader,
  staffNameHeaders,
  staffNameExportHeaders,
  ServicesAddViewHeader,
  StockReportBranchLevelHeader,
  StockReportORSLevelHeader,
  StockReportORSHeader,
  StockReportSDPLevelHeader,
  StockSDPHeader,
  contraceptiveExcelExportHeader,
  consumablesExcelExportHeader,
  medicinesDrugsExcelExportHeader,
  socialMarketingExcelExportHeader,
  brandExcelExportHeaders,
  openingStockExcelExportHeader,
  supplierMasterExcelExportHeader,
  userExcelExportHeaders,
  roleMasterExcelExportHeader,
  CommodityCategoryHeaders,
  UOMHeader,
  contraceptivesGivenRePortHeader,
  clientHeadersExcel,
  cSEInSchoolExcel,
  cSEOutSchoolExcel,
};
